window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },

  resizeSelects: function (selects) {
    selects.forEach(function (select) {
      var arrowWidth = 55;

      var test = document.createElement("span");
      test.innerHTML = select.selectedOptions[0].label;

      document.querySelector(".site-footer").appendChild(test);

      var width = test.offsetWidth + arrowWidth;
      test.remove();

      select.style.width = width + "px";
    });
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39,
  },
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  state: {
    firstFocusable: null,
    lastFocusable: null,
  },
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects
   *
   * @param {HTMLElement} element - The element to be acted upon
   */
  pageLinkFocus: function (element) {
    if (!element) return;
    var focusClass = "js-focus-hidden";

    element.setAttribute("tabIndex", "-1");
    element.focus();
    element.classList.add(focusClass);
    element.addEventListener("blur", callback, { once: true });

    function callback() {
      element.classList.remove(focusClass);
      element.removeAttribute("tabindex");
    }
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
   */
  trapFocus: function (options) {
    var focusableElements = Array.from(
      options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      )
    ).filter(function (element) {
      var width = element.offsetWidth;
      var height = element.offsetHeight;

      return (
        width !== 0 &&
        height !== 0 &&
        getComputedStyle(element).getPropertyValue("display") !== "none"
      );
    });

    this.state.firstFocusable = focusableElements[0];
    this.state.lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute("tabindex", "-1");
    options.elementToFocus.focus();

    this._setupHandlers();

    document.addEventListener("focusin", this._onFocusInHandler);
    document.addEventListener("focusout", this._onFocusOutHandler);
  },

  _setupHandlers: function () {
    if (!this._onFocusInHandler) {
      this._onFocusInHandler = this._onFocusIn.bind(this);
    }

    if (!this._onFocusOutHandler) {
      this._onFocusOutHandler = this._onFocusIn.bind(this);
    }

    if (!this._manageFocusHandler) {
      this._manageFocusHandler = this._manageFocus.bind(this);
    }
  },

  _onFocusOut: function () {
    document.removeEventListener("keydown", this._manageFocusHandler);
  },

  _onFocusIn: function (evt) {
    if (
      evt.target !== this.state.lastFocusable &&
      evt.target !== this.state.firstFocusable
    )
      return;

    document.addEventListener("keydown", this._manageFocusHandler);
  },

  _manageFocus: function (evt) {
    if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

    /**
     * On the last focusable element and tab forward,
     * focus the first element.
     */
    if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
      evt.preventDefault();
      this.state.firstFocusable.focus();
    }
    /**
     * On the first focusable element and tab backward,
     * focus the last element.
     */
    if (evt.target === this.state.firstFocusable && evt.shiftKey) {
      evt.preventDefault();
      this.state.lastFocusable.focus();
    }
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   */
  removeTrapFocus: function (options) {
    if (options.container) {
      options.container.removeAttribute("tabindex");
    }
    document.removeEventListener("focusin", this._onFocusInHandler);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {HTMLElement} options.links - Specific links to be targeted
   */
  accessibleLinks: function (options) {
    var body = document.querySelector("body");

    var idSelectors = {
      newWindow: "a11y-new-window-message",
      external: "a11y-external-message",
      newWindowExternal: "a11y-new-window-external-message",
    };

    if (options.links === undefined || !options.links.length) {
      options.links = document.querySelectorAll(
        "a[href]:not([aria-describedby])"
      );
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== "object") {
        customMessages = {};
      }

      var messages = Object.assign(
        {
          newWindow: "Opens in a new window.",
          external: "Opens external website.",
          newWindowExternal: "Opens external website in a new window.",
        },
        customMessages
      );

      var container = document.createElement("ul");
      var htmlMessages = "";

      for (var message in messages) {
        htmlMessages +=
          "<li id=" + idSelectors[message] + ">" + messages[message] + "</li>";
      }

      container.setAttribute("hidden", true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite(link) {
      var hostname = window.location.hostname;

      return link.hostname !== hostname;
    }

    options.links.forEach(function (link) {
      var target = link.getAttribute("target");
      var rel = link.getAttribute("rel");
      var isExternal = _externalSite(link);
      var isTargetBlank = target === "_blank";

      if (isExternal) {
        link.setAttribute("aria-describedby", idSelectors.external);
      }

      if (isTargetBlank) {
        if (!rel || rel.indexOf("noopener") === -1) {
          var relValue = rel === undefined ? "" : rel + " ";
          relValue = relValue + "noopener";
          link.setAttribute("rel", relValue);
        }

        link.setAttribute("aria-describedby", idSelectors.newWindow);
      }

      if (isExternal && isTargetBlank) {
        link.setAttribute("aria-describedby", idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  },
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
  var moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};
this.Shopify.theme.PredictiveSearch = (function () {
  "use strict";

  function validateQuery(query) {
    var error;

    if (query === null || query === undefined) {
      error = new TypeError("'query' is missing");
      error.type = "argument";
      throw error;
    }

    if (typeof query !== "string") {
      error = new TypeError("'query' is not a string");
      error.type = "argument";
      throw error;
    }
  }

  function GenericError() {
    var error = Error.call(this);

    error.name = "Server error";
    error.message = "Something went wrong on the server";
    error.status = 500;

    return error;
  }

  function NotFoundError(status) {
    var error = Error.call(this);

    error.name = "Not found";
    error.message = "Not found";
    error.status = status;

    return error;
  }

  function ServerError() {
    var error = Error.call(this);

    error.name = "Server error";
    error.message = "Something went wrong on the server";
    error.status = 500;

    return error;
  }

  function ContentTypeError(status) {
    var error = Error.call(this);

    error.name = "Content-Type error";
    error.message = "Content-Type was not provided or is of wrong type";
    error.status = status;

    return error;
  }

  function JsonParseError(status) {
    var error = Error.call(this);

    error.name = "JSON parse error";
    error.message = "JSON syntax error";
    error.status = status;

    return error;
  }

  function ThrottledError(status, name, message, retryAfter) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;
    error.retryAfter = retryAfter;

    return error;
  }

  function InvalidParameterError(status, name, message) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;

    return error;
  }

  function ExpectationFailedError(status, name, message) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;

    return error;
  }

  function request(searchUrl, queryParams, query, onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    var route = searchUrl + "/suggest.json";

    xhr.onreadystatechange = function () {
      if (xhr.readyState !== XMLHttpRequest.DONE) {
        return;
      }

      var contentType = xhr.getResponseHeader("Content-Type");

      if (xhr.status >= 500) {
        onError(new ServerError());

        return;
      }

      if (xhr.status === 404) {
        onError(new NotFoundError(xhr.status));

        return;
      }

      if (
        typeof contentType !== "string" ||
        contentType.toLowerCase().match("application/json") === null
      ) {
        onError(new ContentTypeError(xhr.status));

        return;
      }

      if (xhr.status === 417) {
        try {
          var invalidParameterJson = JSON.parse(xhr.responseText);

          onError(
            new InvalidParameterError(
              xhr.status,
              invalidParameterJson.message,
              invalidParameterJson.description
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 422) {
        try {
          var expectationFailedJson = JSON.parse(xhr.responseText);

          onError(
            new ExpectationFailedError(
              xhr.status,
              expectationFailedJson.message,
              expectationFailedJson.description
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 429) {
        try {
          var throttledJson = JSON.parse(xhr.responseText);

          onError(
            new ThrottledError(
              xhr.status,
              throttledJson.message,
              throttledJson.description,
              xhr.getResponseHeader("Retry-After")
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 200) {
        try {
          var res = JSON.parse(xhr.responseText);
          res.query = query;
          onSuccess(res);
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      try {
        var genericErrorJson = JSON.parse(xhr.responseText);
        onError(
          new GenericError(
            xhr.status,
            genericErrorJson.message,
            genericErrorJson.description
          )
        );
      } catch (error) {
        onError(new JsonParseError(xhr.status));
      }

      return;
    };

    xhr.open(
      "get",
      route + "?q=" + encodeURIComponent(query) + "&" + queryParams
    );

    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.send();
  }

  function Cache(config) {
    this._store = {};
    this._keys = [];
    if (config && config.bucketSize) {
      this.bucketSize = config.bucketSize;
    } else {
      this.bucketSize = 20;
    }
  }

  Cache.prototype.set = function (key, value) {
    if (this.count() >= this.bucketSize) {
      var deleteKey = this._keys.splice(0, 1);
      this.delete(deleteKey);
    }

    this._keys.push(key);
    this._store[key] = value;

    return this._store;
  };

  Cache.prototype.get = function (key) {
    return this._store[key];
  };

  Cache.prototype.has = function (key) {
    return Boolean(this._store[key]);
  };

  Cache.prototype.count = function () {
    return Object.keys(this._store).length;
  };

  Cache.prototype.delete = function (key) {
    var exists = Boolean(this._store[key]);
    delete this._store[key];
    return exists && !this._store[key];
  };

  function Dispatcher() {
    this.events = {};
  }

  Dispatcher.prototype.on = function (eventName, callback) {
    var event = this.events[eventName];
    if (!event) {
      event = new DispatcherEvent(eventName);
      this.events[eventName] = event;
    }
    event.registerCallback(callback);
  };

  Dispatcher.prototype.off = function (eventName, callback) {
    var event = this.events[eventName];
    if (event && event.callbacks.indexOf(callback) > -1) {
      event.unregisterCallback(callback);
      if (event.callbacks.length === 0) {
        delete this.events[eventName];
      }
    }
  };

  Dispatcher.prototype.dispatch = function (eventName, payload) {
    var event = this.events[eventName];
    if (event) {
      event.fire(payload);
    }
  };

  function DispatcherEvent(eventName) {
    this.eventName = eventName;
    this.callbacks = [];
  }

  DispatcherEvent.prototype.registerCallback = function (callback) {
    this.callbacks.push(callback);
  };

  DispatcherEvent.prototype.unregisterCallback = function (callback) {
    var index = this.callbacks.indexOf(callback);
    if (index > -1) {
      this.callbacks.splice(index, 1);
    }
  };

  DispatcherEvent.prototype.fire = function (payload) {
    var callbacks = this.callbacks.slice(0);
    callbacks.forEach(function (callback) {
      callback(payload);
    });
  };

  function debounce(func, wait) {
    var timeout = null;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        timeout = null;
        func.apply(context, args);
      }, wait || 0);
    };
  }

  function objectToQueryParams(obj, parentKey) {
    var output = "";
    parentKey = parentKey || null;

    Object.keys(obj).forEach(function (key) {
      var outputKey = key + "=";
      if (parentKey) {
        outputKey = parentKey + "[" + key + "]";
      }

      switch (trueTypeOf(obj[key])) {
        case "object":
          output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
          break;
        case "array":
          output += outputKey + "=" + obj[key].join(",") + "&";
          break;
        default:
          if (parentKey) {
            outputKey += "=";
          }
          output += outputKey + encodeURIComponent(obj[key]) + "&";
          break;
      }
    });

    return output;
  }

  function trueTypeOf(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
  }

  var DEBOUNCE_RATE = 10;
  var requestDebounced = debounce(request, DEBOUNCE_RATE);

  function PredictiveSearch(params, searchUrl) {
    if (!params) {
      throw new TypeError("No params object was specified");
    }

    this.searchUrl = searchUrl;

    this._retryAfter = null;
    this._currentQuery = null;

    this.dispatcher = new Dispatcher();
    this.cache = new Cache({ bucketSize: 40 });

    this.queryParams = objectToQueryParams(params);
  }

  PredictiveSearch.TYPES = {
    PRODUCT: "product",
    PAGE: "page",
    ARTICLE: "article",
  };

  PredictiveSearch.FIELDS = {
    AUTHOR: "author",
    BODY: "body",
    PRODUCT_TYPE: "product_type",
    TAG: "tag",
    TITLE: "title",
    VARIANTS_BARCODE: "variants.barcode",
    VARIANTS_SKU: "variants.sku",
    VARIANTS_TITLE: "variants.title",
    VENDOR: "vendor",
  };

  PredictiveSearch.UNAVAILABLE_PRODUCTS = {
    SHOW: "show",
    HIDE: "hide",
    LAST: "last",
  };

  PredictiveSearch.prototype.query = function query(query) {
    try {
      validateQuery(query);
    } catch (error) {
      this.dispatcher.dispatch("error", error);
      return;
    }

    if (query === "") {
      return this;
    }

    this._currentQuery = normalizeQuery(query);
    var cacheResult = this.cache.get(this._currentQuery);
    if (cacheResult) {
      this.dispatcher.dispatch("success", cacheResult);
      return this;
    }

    requestDebounced(
      this.searchUrl,
      this.queryParams,
      query,
      function (result) {
        this.cache.set(normalizeQuery(result.query), result);
        if (normalizeQuery(result.query) === this._currentQuery) {
          this._retryAfter = null;
          this.dispatcher.dispatch("success", result);
        }
      }.bind(this),
      function (error) {
        if (error.retryAfter) {
          this._retryAfter = error.retryAfter;
        }
        this.dispatcher.dispatch("error", error);
      }.bind(this)
    );

    return this;
  };

  PredictiveSearch.prototype.on = function on(eventName, callback) {
    this.dispatcher.on(eventName, callback);

    return this;
  };

  PredictiveSearch.prototype.off = function on(eventName, callback) {
    this.dispatcher.off(eventName, callback);

    return this;
  };

  function normalizeQuery(query) {
    if (typeof query !== "string") {
      return null;
    }

    return query.trim().replace(" ", "-").toLowerCase();
  }

  return PredictiveSearch;
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};
this.Shopify.theme.PredictiveSearchComponent = (function (PredictiveSearch) {
  "use strict";

  PredictiveSearch =
    PredictiveSearch && PredictiveSearch.hasOwnProperty("default")
      ? PredictiveSearch["default"]
      : PredictiveSearch;

  var DEFAULT_PREDICTIVE_SEARCH_API_CONFIG = {
    resources: {
      type: [PredictiveSearch.TYPES.PRODUCT],
      options: {
        unavailable_products: PredictiveSearch.UNAVAILABLE_PRODUCTS.LAST,
        fields: [
          PredictiveSearch.FIELDS.TITLE,
          PredictiveSearch.FIELDS.VENDOR,
          PredictiveSearch.FIELDS.PRODUCT_TYPE,
          PredictiveSearch.FIELDS.VARIANTS_TITLE,
        ],
      },
    },
  };

  function PredictiveSearchComponent(config) {
    // validate config
    if (
      !config ||
      !config.selectors ||
      !config.selectors.input ||
      !isString(config.selectors.input) ||
      !config.selectors.result ||
      !isString(config.selectors.result) ||
      !config.resultTemplateFct ||
      !isFunction(config.resultTemplateFct) ||
      !config.numberOfResultsTemplateFct ||
      !isFunction(config.numberOfResultsTemplateFct) ||
      !config.loadingResultsMessageTemplateFct ||
      !isFunction(config.loadingResultsMessageTemplateFct)
    ) {
      var error = new TypeError(
        "PredictiveSearchComponent config is not valid"
      );
      error.type = "argument";
      throw error;
    }

    // Find nodes
    this.nodes = findNodes(config.selectors);

    // Validate nodes
    if (!isValidNodes(this.nodes)) {
      // eslint-disable-next-line no-console
      console.warn("Could not find valid nodes");
      return;
    }

    this.searchUrl = config.searchUrl || "/search";

    // Store the keyword that was used for the search
    this._searchKeyword = "";

    // Assign result template
    this.resultTemplateFct = config.resultTemplateFct;

    // Assign number of results template
    this.numberOfResultsTemplateFct = config.numberOfResultsTemplateFct;

    // Assign loading state template function
    this.loadingResultsMessageTemplateFct =
      config.loadingResultsMessageTemplateFct;

    // Assign number of search results
    this.numberOfResults = config.numberOfResults || 4;

    // Set classes
    this.classes = {
      visibleVariant: config.visibleVariant
        ? config.visibleVariant
        : "predictive-search-wrapper--visible",
      itemSelected: config.itemSelectedClass
        ? config.itemSelectedClass
        : "predictive-search-item--selected",
      clearButtonVisible: config.clearButtonVisibleClass
        ? config.clearButtonVisibleClass
        : "predictive-search__clear-button--visible",
    };

    this.selectors = {
      searchResult: config.searchResult
        ? config.searchResult
        : "[data-search-result]",
    };

    // Assign callbacks
    this.callbacks = assignCallbacks(config);

    // Add input attributes
    addInputAttributes(this.nodes.input);

    // Add input event listeners
    this._addInputEventListeners();

    // Add body listener
    this._addBodyEventListener();

    // Add accessibility announcer
    this._addAccessibilityAnnouncer();

    // Display the reset button if the input is not empty
    this._toggleClearButtonVisibility();

    // Instantiate Predictive Search API
    this.predictiveSearch = new PredictiveSearch(
      config.PredictiveSearchAPIConfig
        ? config.PredictiveSearchAPIConfig
        : DEFAULT_PREDICTIVE_SEARCH_API_CONFIG,
      this.searchUrl
    );

    // Add predictive search success event listener
    this.predictiveSearch.on(
      "success",
      this._handlePredictiveSearchSuccess.bind(this)
    );

    // Add predictive search error event listener
    this.predictiveSearch.on(
      "error",
      this._handlePredictiveSearchError.bind(this)
    );
  }

  /**
   * Private methods
   */
  function findNodes(selectors) {
    return {
      input: document.querySelector(selectors.input),
      reset: document.querySelector(selectors.reset),
      result: document.querySelector(selectors.result),
    };
  }

  function isValidNodes(nodes) {
    if (
      !nodes ||
      !nodes.input ||
      !nodes.result ||
      nodes.input.tagName !== "INPUT"
    ) {
      return false;
    }

    return true;
  }

  function assignCallbacks(config) {
    return {
      onBodyMousedown: config.onBodyMousedown,
      onBeforeOpen: config.onBeforeOpen,
      onOpen: config.onOpen,
      onBeforeClose: config.onBeforeClose,
      onClose: config.onClose,
      onInputFocus: config.onInputFocus,
      onInputKeyup: config.onInputKeyup,
      onInputBlur: config.onInputBlur,
      onInputReset: config.onInputReset,
      onBeforeDestroy: config.onBeforeDestroy,
      onDestroy: config.onDestroy,
    };
  }

  function addInputAttributes(input) {
    input.setAttribute("autocorrect", "off");
    input.setAttribute("autocomplete", "off");
    input.setAttribute("autocapitalize", "off");
    input.setAttribute("spellcheck", "false");
  }

  function removeInputAttributes(input) {
    input.removeAttribute("autocorrect", "off");
    input.removeAttribute("autocomplete", "off");
    input.removeAttribute("autocapitalize", "off");
    input.removeAttribute("spellcheck", "false");
  }

  /**
   * Public variables
   */
  PredictiveSearchComponent.prototype.isResultVisible = false;
  PredictiveSearchComponent.prototype.results = {};

  /**
   * "Private" variables
   */
  PredictiveSearchComponent.prototype._latencyTimer = null;
  PredictiveSearchComponent.prototype._resultNodeClicked = false;

  /**
   * "Private" instance methods
   */
  PredictiveSearchComponent.prototype._addInputEventListeners = function () {
    var input = this.nodes.input;
    var reset = this.nodes.reset;

    if (!input) {
      return;
    }

    this._handleInputFocus = this._handleInputFocus.bind(this);
    this._handleInputBlur = this._handleInputBlur.bind(this);
    this._handleInputKeyup = this._handleInputKeyup.bind(this);
    this._handleInputKeydown = this._handleInputKeydown.bind(this);

    input.addEventListener("focus", this._handleInputFocus);
    input.addEventListener("blur", this._handleInputBlur);
    input.addEventListener("keyup", this._handleInputKeyup);
    input.addEventListener("keydown", this._handleInputKeydown);

    if (reset) {
      this._handleInputReset = this._handleInputReset.bind(this);
      reset.addEventListener("click", this._handleInputReset);
    }
  };

  PredictiveSearchComponent.prototype._removeInputEventListeners = function () {
    var input = this.nodes.input;

    input.removeEventListener("focus", this._handleInputFocus);
    input.removeEventListener("blur", this._handleInputBlur);
    input.removeEventListener("keyup", this._handleInputKeyup);
    input.removeEventListener("keydown", this._handleInputKeydown);
  };

  PredictiveSearchComponent.prototype._addBodyEventListener = function () {
    this._handleBodyMousedown = this._handleBodyMousedown.bind(this);

    document
      .querySelector("body")
      .addEventListener("mousedown", this._handleBodyMousedown);
  };

  PredictiveSearchComponent.prototype._removeBodyEventListener = function () {
    document
      .querySelector("body")
      .removeEventListener("mousedown", this._handleBodyMousedown);
  };

  PredictiveSearchComponent.prototype._removeClearButtonEventListener =
    function () {
      var reset = this.nodes.reset;

      if (!reset) {
        return;
      }

      reset.removeEventListener("click", this._handleInputReset);
    };

  /**
   * Event handlers
   */
  PredictiveSearchComponent.prototype._handleBodyMousedown = function (evt) {
    if (this.isResultVisible && this.nodes !== null) {
      if (
        evt.target.isEqualNode(this.nodes.input) ||
        this.nodes.input.contains(evt.target) ||
        evt.target.isEqualNode(this.nodes.result) ||
        this.nodes.result.contains(evt.target)
      ) {
        this._resultNodeClicked = true;
      } else {
        if (isFunction(this.callbacks.onBodyMousedown)) {
          var returnedValue = this.callbacks.onBodyMousedown(this.nodes);
          if (isBoolean(returnedValue) && returnedValue) {
            this.close();
          }
        } else {
          this.close();
        }
      }
    }
  };

  PredictiveSearchComponent.prototype._handleInputFocus = function (evt) {
    if (isFunction(this.callbacks.onInputFocus)) {
      var returnedValue = this.callbacks.onInputFocus(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    if (evt.target.value.length > 0) {
      this._search();
    }

    return true;
  };

  PredictiveSearchComponent.prototype._handleInputBlur = function () {
    // This has to be done async, to wait for the focus to be on the next
    // element and avoid closing the results.
    // Example: Going from the input to the reset button.
    setTimeout(
      function () {
        if (isFunction(this.callbacks.onInputBlur)) {
          var returnedValue = this.callbacks.onInputBlur(this.nodes);
          if (isBoolean(returnedValue) && !returnedValue) {
            return false;
          }
        }

        if (document.activeElement.isEqualNode(this.nodes.reset)) {
          return false;
        }

        if (this._resultNodeClicked) {
          this._resultNodeClicked = false;
          return false;
        }

        this.close();
      }.bind(this)
    );

    return true;
  };

  PredictiveSearchComponent.prototype._addAccessibilityAnnouncer = function () {
    this._accessibilityAnnouncerDiv = window.document.createElement("div");

    this._accessibilityAnnouncerDiv.setAttribute(
      "style",
      "position: absolute !important; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;"
    );

    this._accessibilityAnnouncerDiv.setAttribute("data-search-announcer", "");
    this._accessibilityAnnouncerDiv.setAttribute("aria-live", "polite");
    this._accessibilityAnnouncerDiv.setAttribute("aria-atomic", "true");

    this.nodes.result.parentElement.appendChild(
      this._accessibilityAnnouncerDiv
    );
  };

  PredictiveSearchComponent.prototype._removeAccessibilityAnnouncer =
    function () {
      this.nodes.result.parentElement.removeChild(
        this._accessibilityAnnouncerDiv
      );
    };

  PredictiveSearchComponent.prototype._updateAccessibilityAttributesAfterSelectingElement =
    function (previousSelectedElement, currentSelectedElement) {
      // Update the active descendant on the search input
      this.nodes.input.setAttribute(
        "aria-activedescendant",
        currentSelectedElement.id
      );

      // Unmark the previousSelected elemented as selected
      if (previousSelectedElement) {
        previousSelectedElement.removeAttribute("aria-selected");
      }

      // Mark the element as selected
      currentSelectedElement.setAttribute("aria-selected", true);
    };

  PredictiveSearchComponent.prototype._clearAriaActiveDescendant = function () {
    this.nodes.input.setAttribute("aria-activedescendant", "");
  };

  PredictiveSearchComponent.prototype._announceNumberOfResultsFound = function (
    results
  ) {
    var currentAnnouncedMessage = this._accessibilityAnnouncerDiv.innerHTML;
    var newMessage = this.numberOfResultsTemplateFct(results);

    // If the messages are the same, they won't get announced
    // add white space so it gets announced
    if (currentAnnouncedMessage === newMessage) {
      newMessage = newMessage + "&nbsp;";
    }

    this._accessibilityAnnouncerDiv.innerHTML = newMessage;
  };

  PredictiveSearchComponent.prototype._announceLoadingState = function () {
    this._accessibilityAnnouncerDiv.innerHTML =
      this.loadingResultsMessageTemplateFct();
  };

  PredictiveSearchComponent.prototype._handleInputKeyup = function (evt) {
    var UP_ARROW_KEY_CODE = 38;
    var DOWN_ARROW_KEY_CODE = 40;
    var RETURN_KEY_CODE = 13;
    var ESCAPE_KEY_CODE = 27;

    if (isFunction(this.callbacks.onInputKeyup)) {
      var returnedValue = this.callbacks.onInputKeyup(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this._toggleClearButtonVisibility();

    if (this.isResultVisible && this.nodes !== null) {
      if (evt.keyCode === UP_ARROW_KEY_CODE) {
        this._navigateOption(evt, "UP");
        return true;
      }

      if (evt.keyCode === DOWN_ARROW_KEY_CODE) {
        this._navigateOption(evt, "DOWN");
        return true;
      }

      if (evt.keyCode === RETURN_KEY_CODE) {
        this._selectOption();
        return true;
      }

      if (evt.keyCode === ESCAPE_KEY_CODE) {
        this.close();
      }
    }

    if (evt.target.value.length <= 0) {
      this.close();
      this._setKeyword("");
    } else if (evt.target.value.length > 0) {
      this._search();
    }

    return true;
  };

  PredictiveSearchComponent.prototype._handleInputKeydown = function (evt) {
    var RETURN_KEY_CODE = 13;
    var UP_ARROW_KEY_CODE = 38;
    var DOWN_ARROW_KEY_CODE = 40;

    // Prevent the form default submission if there is a selected option
    if (evt.keyCode === RETURN_KEY_CODE && this._getSelectedOption() !== null) {
      evt.preventDefault();
    }

    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      evt.keyCode === UP_ARROW_KEY_CODE ||
      evt.keyCode === DOWN_ARROW_KEY_CODE
    ) {
      evt.preventDefault();
    }
  };

  PredictiveSearchComponent.prototype._handleInputReset = function (evt) {
    evt.preventDefault();

    if (isFunction(this.callbacks.onInputReset)) {
      var returnedValue = this.callbacks.onInputReset(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.input.value = "";
    this.nodes.input.focus();
    this._toggleClearButtonVisibility();
    this.close();

    return true;
  };

  PredictiveSearchComponent.prototype._navigateOption = function (
    evt,
    direction
  ) {
    var currentOption = this._getSelectedOption();

    if (!currentOption) {
      var firstOption = this.nodes.result.querySelector(
        this.selectors.searchResult
      );
      firstOption.classList.add(this.classes.itemSelected);
      this._updateAccessibilityAttributesAfterSelectingElement(
        null,
        firstOption
      );
    } else {
      if (direction === "DOWN") {
        var nextOption = currentOption.nextElementSibling;
        if (nextOption) {
          currentOption.classList.remove(this.classes.itemSelected);
          nextOption.classList.add(this.classes.itemSelected);
          this._updateAccessibilityAttributesAfterSelectingElement(
            currentOption,
            nextOption
          );
        }
      } else {
        var previousOption = currentOption.previousElementSibling;
        if (previousOption) {
          currentOption.classList.remove(this.classes.itemSelected);
          previousOption.classList.add(this.classes.itemSelected);
          this._updateAccessibilityAttributesAfterSelectingElement(
            currentOption,
            previousOption
          );
        }
      }
    }
  };

  PredictiveSearchComponent.prototype._getSelectedOption = function () {
    return this.nodes.result.querySelector("." + this.classes.itemSelected);
  };

  PredictiveSearchComponent.prototype._selectOption = function () {
    var selectedOption = this._getSelectedOption();

    if (selectedOption) {
      selectedOption.querySelector("a, button").click();
    }
  };

  PredictiveSearchComponent.prototype._search = function () {
    var newSearchKeyword = this.nodes.input.value;

    if (this._searchKeyword === newSearchKeyword) {
      return;
    }

    clearTimeout(this._latencyTimer);
    this._latencyTimer = setTimeout(
      function () {
        this.results.isLoading = true;

        // Annonuce that we're loading the results
        this._announceLoadingState();

        this.nodes.result.classList.add(this.classes.visibleVariant);
        // NOTE: We could benifit in using DOMPurify.
        // https://github.com/cure53/DOMPurify
        this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
      }.bind(this),
      500
    );

    this.predictiveSearch.query(newSearchKeyword);
    this._setKeyword(newSearchKeyword);
  };

  PredictiveSearchComponent.prototype._handlePredictiveSearchSuccess =
    function (json) {
      clearTimeout(this._latencyTimer);
      this.results = json.resources.results;

      this.results.isLoading = false;
      this.results.products = this.results.products.slice(
        0,
        this.numberOfResults
      );
      this.results.canLoadMore =
        this.numberOfResults <= this.results.products.length;
      this.results.searchQuery = this.nodes.input.value;

      if (this.results.products.length > 0 || this.results.searchQuery) {
        this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
        this._announceNumberOfResultsFound(this.results);
        this.open();
      } else {
        this.nodes.result.innerHTML = "";

        this._closeOnNoResults();
      }
    };

  PredictiveSearchComponent.prototype._handlePredictiveSearchError =
    function () {
      clearTimeout(this._latencyTimer);
      this.nodes.result.innerHTML = "";

      this._closeOnNoResults();
    };

  PredictiveSearchComponent.prototype._closeOnNoResults = function () {
    if (this.nodes) {
      this.nodes.result.classList.remove(this.classes.visibleVariant);
    }

    this.isResultVisible = false;
  };

  PredictiveSearchComponent.prototype._setKeyword = function (keyword) {
    this._searchKeyword = keyword;
  };

  PredictiveSearchComponent.prototype._toggleClearButtonVisibility =
    function () {
      if (!this.nodes.reset) {
        return;
      }

      if (this.nodes.input.value.length > 0) {
        this.nodes.reset.classList.add(this.classes.clearButtonVisible);
      } else {
        this.nodes.reset.classList.remove(this.classes.clearButtonVisible);
      }
    };

  /**
   * Public methods
   */
  PredictiveSearchComponent.prototype.open = function () {
    if (this.isResultVisible) {
      return;
    }

    if (isFunction(this.callbacks.onBeforeOpen)) {
      var returnedValue = this.callbacks.onBeforeOpen(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.result.classList.add(this.classes.visibleVariant);
    this.nodes.input.setAttribute("aria-expanded", true);
    this.isResultVisible = true;

    if (isFunction(this.callbacks.onOpen)) {
      return this.callbacks.onOpen(this.nodes) || true;
    }

    return true;
  };

  PredictiveSearchComponent.prototype.close = function () {
    if (!this.isResultVisible) {
      return true;
    }

    if (isFunction(this.callbacks.onBeforeClose)) {
      var returnedValue = this.callbacks.onBeforeClose(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    if (this.nodes) {
      this.nodes.result.classList.remove(this.classes.visibleVariant);
    }

    this.nodes.input.setAttribute("aria-expanded", false);
    this._clearAriaActiveDescendant();
    this._setKeyword("");

    if (isFunction(this.callbacks.onClose)) {
      this.callbacks.onClose(this.nodes);
    }

    this.isResultVisible = false;
    this.results = {};

    return true;
  };

  PredictiveSearchComponent.prototype.destroy = function () {
    this.close();

    if (isFunction(this.callbacks.onBeforeDestroy)) {
      var returnedValue = this.callbacks.onBeforeDestroy(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.result.classList.remove(this.classes.visibleVariant);
    removeInputAttributes(this.nodes.input);
    this._removeInputEventListeners();
    this._removeBodyEventListener();
    this._removeAccessibilityAnnouncer();
    this._removeClearButtonEventListener();

    if (isFunction(this.callbacks.onDestroy)) {
      this.callbacks.onDestroy(this.nodes);
    }

    return true;
  };

  PredictiveSearchComponent.prototype.clearAndClose = function () {
    this.nodes.input.value = "";
    this.close();
  };

  /**
   * Utilities
   */
  function getTypeOf(value) {
    return Object.prototype.toString.call(value);
  }

  function isString(value) {
    return getTypeOf(value) === "[object String]";
  }

  function isBoolean(value) {
    return getTypeOf(value) === "[object Boolean]";
  }

  function isFunction(value) {
    return getTypeOf(value) === "[object Function]";
  }

  return PredictiveSearchComponent;
})(Shopify.theme.PredictiveSearch);

window.theme = window.theme || {};

/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
  function Drawer(id, position, options) {
    var DEFAULT_OPEN_CLASS = "js-drawer-open";
    var DEFAULT_CLOSE_CLASS = "js-drawer-close";

    var defaults = {
      selectors: {
        openVariant: "." + DEFAULT_OPEN_CLASS + "-" + position,
        close: "." + DEFAULT_CLOSE_CLASS,
      },
      classes: {
        open: DEFAULT_OPEN_CLASS,
        openVariant: DEFAULT_OPEN_CLASS + "-" + position,
      },
      withPredictiveSearch: false,
    };

    this.nodes = {
      parents: [document.documentElement, document.body],
      page: document.getElementById("PageContainer"),
    };

    this.eventHandlers = {};

    this.config = Object.assign({}, defaults, options);
    this.position = position;
    this.drawer = document.getElementById(id);

    if (!this.drawer) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function () {
    document
      .querySelector(this.config.selectors.openVariant)
      .addEventListener("click", this.open.bind(this));
    this.drawer
      .querySelector(this.config.selectors.close)
      .addEventListener("click", this.close.bind(this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.activeSource = evt.currentTarget;
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    if (!this.config.withPredictiveSearch) {
      theme.Helpers.prepareTransition(this.drawer);
    }

    this.nodes.parents.forEach(
      function (parent) {
        parent.classList.add(
          this.config.classes.open,
          this.config.classes.openVariant
        );
      }.bind(this)
    );

    this.drawerIsOpen = true;

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === "function"
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.activeSource && this.activeSource.hasAttribute("aria-expanded")) {
      this.activeSource.setAttribute("aria-expanded", "true");
    }

    // Set focus on drawer
    var trapFocusConfig = {
      container: this.drawer,
    };

    if (this.config.elementToFocusOnOpen) {
      trapFocusConfig.elementToFocus = this.config.elementToFocusOnOpen;
    }

    slate.a11y.trapFocus(trapFocusConfig);

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    document.activeElement.dispatchEvent(
      new CustomEvent("blur", { bubbles: true, cancelable: true })
    );

    // Ensure closing transition is applied to moved elements, like the nav
    if (!this.config.withPredictiveSearch) {
      theme.Helpers.prepareTransition(this.drawer);
    }

    this.nodes.parents.forEach(
      function (parent) {
        parent.classList.remove(
          this.config.classes.open,
          this.config.classes.openVariant
        );
      }.bind(this)
    );

    if (this.activeSource && this.activeSource.hasAttribute("aria-expanded")) {
      this.activeSource.setAttribute("aria-expanded", "false");
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      container: this.drawer,
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === "function"
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function () {
    this.eventHandlers.drawerKeyupHandler = function (evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }.bind(this);

    this.eventHandlers.drawerTouchmoveHandler = function () {
      return false;
    };

    this.eventHandlers.drawerClickHandler = function () {
      this.close();
      return false;
    }.bind(this);

    // Add event listener to document body
    document.body.addEventListener(
      "keyup",
      this.eventHandlers.drawerKeyupHandler
    );

    // Lock scrolling on mobile
    this.nodes.page.addEventListener(
      "touchmove",
      this.eventHandlers.drawerTouchmoveHandler
    );

    this.nodes.page.addEventListener(
      "click",
      this.eventHandlers.drawerClickHandler
    );
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.page.removeEventListener(
      "touchmove",
      this.eventHandlers.drawerTouchmoveHandler
    );
    this.nodes.page.removeEventListener(
      "click",
      this.eventHandlers.drawerClickHandler
    );
    document.body.removeEventListener(
      "keyup",
      this.eventHandlers.drawerKeyupHandler
    );
  };

  return Drawer;
})();

theme.Helpers = (function () {
  var touchDevice = false;

  var classes = {
    preventScrolling: "prevent-scrolling",
  };

  var scrollPosition = window.pageYOffset;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  function enableScrollLock() {
    scrollPosition = window.pageYOffset;
    document.body.style.top = "-" + scrollPosition + "px";
    document.body.classList.add(classes.preventScrolling);
  }

  function disableScrollLock() {
    document.body.classList.remove(classes.preventScrolling);
    document.body.style.removeProperty("top");
    window.scrollTo(0, scrollPosition);
  }

  function debounce(func, wait, immediate) {
    var timeout;

    return function () {
      var context = this,
        args = arguments;

      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function getScript(source, beforeEl) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      var prior = beforeEl || document.getElementsByTagName("script")[0];

      script.async = true;
      script.defer = true;

      // eslint-disable-next-line shopify/prefer-early-return
      function onloadHander(_, isAbort) {
        if (
          isAbort ||
          !script.readyState ||
          /loaded|complete/.test(script.readyState)
        ) {
          script.onload = null;
          script.onreadystatechange = null;
          script = undefined;

          if (isAbort) {
            reject();
          } else {
            resolve();
          }
        }
      }

      script.onload = onloadHander;
      script.onreadystatechange = onloadHander;

      script.src = source;
      prior.parentNode.insertBefore(script, prior);
    });
  }

  /* Based on the prepareTransition by Jonathan Snook */
  /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
  function prepareTransition(element) {
    element.addEventListener(
      "transitionend",
      function (event) {
        event.currentTarget.classList.remove("is-transitioning");
      },
      { once: true }
    );

    var properties = [
      "transition-duration",
      "-moz-transition-duration",
      "-webkit-transition-duration",
      "-o-transition-duration",
    ];

    var duration = 0;

    properties.forEach(function (property) {
      var computedValue = getComputedStyle(element)[property];

      if (computedValue) {
        computedValue.replace(/\D/g, "");
        duration || (duration = parseFloat(computedValue));
      }
    });

    if (duration !== 0) {
      element.classList.add("is-transitioning");
      element.offsetWidth;
    }
  }

  /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */
  function serialize(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (
        !field.name ||
        field.disabled ||
        ["file", "reset", "submit", "button"].indexOf(field.type) > -1
      )
        return;
      if (field.type === "select-multiple") {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
      );
    });
    return arr.join("&");
  }

  function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
    }

    return cookieEnabled;
  }

  function promiseStylesheet(stylesheet) {
    var stylesheetUrl = stylesheet || theme.stylesheet;

    if (typeof this.stylesheetPromise === "undefined") {
      this.stylesheetPromise = new Promise(function (resolve) {
        var link = document.querySelector('link[href="' + stylesheetUrl + '"]');

        if (link.loaded) resolve();

        link.addEventListener("load", function () {
          setTimeout(resolve, 0);
        });
      });
    }

    return this.stylesheetPromise;
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch,
    enableScrollLock: enableScrollLock,
    disableScrollLock: disableScrollLock,
    debounce: debounce,
    getScript: getScript,
    prepareTransition: prepareTransition,
    serialize: serialize,
    cookiesEnabled: cookiesEnabled,
    promiseStylesheet: promiseStylesheet,
  };
})();

theme.LibraryLoader = (function () {
  var types = {
    link: "link",
    script: "script",
  };

  var status = {
    requested: "requested",
    loaded: "loaded",
  };

  var cloudCdn = "https://cdn.shopify.com/shopifycloud/";

  var libraries = {
    plyrShopifyStyles: {
      tagId: "plyr-shopify-styles",
      src: cloudCdn + "plyr/v2.0/shopify-plyr.css",
      type: types.link,
    },
    modelViewerUiStyles: {
      tagId: "shopify-model-viewer-ui-styles",
      src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
      type: types.link,
    },
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function () {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement("script");
    tag.src = library.src;
    tag.addEventListener("load", function () {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement("link");
    tag.href = library.src;
    tag.rel = "stylesheet";
    tag.type = "text/css";
    tag.addEventListener("load", function () {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load,
  };
})();

/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.FormStatus = (function () {
  var selectors = {
    statusMessage: "[data-form-status]",
  };

  function init() {
    var statusMessages = document.querySelectorAll(selectors.statusMessage);

    statusMessages.forEach(function (statusMessage) {
      statusMessage.setAttribute("tabindex", -1);
      statusMessage.focus();

      statusMessage.addEventListener(
        "blur",
        function (evt) {
          evt.target.removeAttribute("tabindex");
        },
        { once: true }
      );
    });
  }

  return {
    init: init,
  };
})();

// prettier-ignore
window.theme = window.theme || {};

theme.SearchResultsTemplate = (function () {
  function renderResults(products, isLoading, searchQuery) {
    return [
      '<div class="predictive-search">',
      renderHeader(products, isLoading),
      renderProducts(products, searchQuery),
      "</div>",
    ].join("");
  }

  function renderHeader(products, isLoading) {
    if (products.length === 0) {
      return "";
    }

    return [
      '<div class="predictive-search-title">',
      '<h3 id="predictive-search" class="predictive-search-title__content">' +
        theme.strings.products +
        "</h3>",
      '<span class="predictive-search-title__loading-spinner">' +
        (isLoading
          ? '<span class= "icon-predictive-search-spinner" ></span >'
          : "") +
        "</span>",
      "</div>",
    ].join("");
  }

  function loadingState() {
    return [
      '<div class="predictive-search">',
      '<div class="predictive-search-loading">',
      '<span class="visually-hidden">' + theme.strings.loading + "</span>",
      '<span class="predictive-search-loading__icon">',
      '<span class="icon-predictive-search-spinner"></span>',
      "</span>",
      "</div>",
      "</div>",
    ].join("");
  }

  function renderViewAll(searchQuery) {
    return [
      '<button type="submit" class="predictive-search-view-all__button" tabindex="-1">',
      theme.strings.searchFor +
        '<span class="predictive-search-view-all__query"> &ldquo;' +
        _htmlEscape(searchQuery) +
        "&rdquo;</span>",
      "</button>",
    ].join("");
  }

  function renderProducts(products, searchQuery) {
    var resultsCount = products.length;

    return [
      '<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">',
      products
        .map(function (product, index) {
          return renderProduct(normalizeProduct(product), index, resultsCount);
        })
        .join(""),
      '<li id="search-all" class="predictive-search-view-all" role="option" data-search-result>' +
        renderViewAll(searchQuery) +
        "</li>",
      "</ul>",
    ].join("");
  }

  function renderProduct(product, index, resultsCount) {
    return [
      '<li id="search-result-' +
        index +
        '" class="predictive-search-item" role="option" data-search-result>',
      '<a class="predictive-search-item__link" href="' +
        product.url +
        '" tabindex="-1">',
      '<div class="predictive-search__column predictive-search__column--image" data-image-loading-animation>',
      renderProductImage(product),
      "</div>",
      '<div class="predictive-search__column predictive-search__column--content ' +
        (getDetailsCount() ? "" : "predictive-search__column--center") +
        '">',
      '<span class="predictive-search-item__title">',
      '<span class="predictive-search-item__title-text">' +
        product.title +
        "</span>",
      "</span>" + (getDetailsCount() ? renderProductDetails(product) : ""),
      '<span class="visually-hidden">, </span>',
      '<span class="visually-hidden">' +
        getNumberOfResultsString(index + 1, resultsCount) +
        "</span>",
      "</div>",
      "</a>",
      "</li>",
    ].join("");
  }

  function renderProductImage(product) {
    if (product.image === null) {
      return "";
    }

    return (
      '<img class="predictive-search-item__image lazyload" src="' +
      product.image.url +
      '" data-src="' +
      product.image.url +
      '" data-image alt="' +
      product.image.alt +
      '" />'
    );
  }

  function renderProductDetails(product) {
    return [
      '<dl class="predictive-search-item__details price' +
        (product.isOnSale ? " price--on-sale" : "") +
        (!product.available ? " price--sold-out" : "") +
        (!product.isPriceVaries && product.isCompareVaries
          ? " price--compare-price-hidden"
          : "") +
        '">',
      '<div class="predictive-search-item__detail">',
      renderVendor(product),
      "</div>",
      '<div class="predictive-search-item__detail predictive-search-item__detail--inline">' +
        renderProductPrice(product),
      "</div>",
      "</dl>",
    ].join("");
  }
  function renderProductPrice(product) {
    if (!theme.settings.predictiveSearchShowPrice) {
      return "";
    }

    var accessibilityAnnounceComma = '<span class="visually-hidden">, </span>';

    var priceMarkup =
      '<div class="price__regular">' + renderPrice(product) + "</div>";

    var salePriceMarkup =
      '<div class="price__sale">' + renderSalePrice(product) + "</div>";

    return (
      accessibilityAnnounceComma +
      '<div class="price__pricing-group">' +
      (product.isOnSale ? salePriceMarkup : priceMarkup) +
      "</div>"
    );
  }

  function renderSalePrice(product) {
    return [
      "<dt>",
      '<span class="visually-hidden">' + theme.strings.salePrice + "</span>",
      "</dt>",
      "<dd>",
      '<span class="predictive-search-item__price predictive-search-item__price--sale">' +
        (product.isPriceVaries
          ? theme.strings.fromLowestPrice.replace("[price]", product.price)
          : product.price) +
        "</span>",
      "</dd>",
      '<div class="price__compare">' + renderCompareAtPrice(product) + "</div>",
    ].join("");
  }

  function renderCompareAtPrice(product) {
    return [
      "<dt>",
      '<span class="visually-hidden">' +
        theme.strings.regularPrice +
        "</span> ",
      "</dt>",
      "<dd>",
      '<span class="predictive-search-item__price predictive-search-item__price--compare">' +
        product.compareAtPrice +
        "</span>",
      "</dd>",
    ].join("");
  }

  function renderPrice(product) {
    return [
      "<dt>",
      '<span class="visually-hidden">' + theme.strings.regularPrice + "</span>",
      "</dt>",
      "<dd>",
      '<span class="predictive-search-item__price">' +
        (product.isPriceVaries
          ? theme.strings.fromLowestPrice.replace("[price]", product.price)
          : product.price) +
        "</span>",
      "</dd>",
    ].join("");
  }

  function renderVendor(product) {
    if (!theme.settings.predictiveSearchShowVendor || product.vendor === "") {
      return "";
    }

    return [
      "<dt>",
      '<span class="visually-hidden">' + theme.strings.vendor + "</span>",
      "</dt>",
      '<dd class="predictive-search-item__vendor">' + product.vendor + "</dd>",
    ].join("");
  }

  function normalizeProduct(product) {
    var productOrVariant =
      product.variants.length > 0 ? product.variants[0] : product;

    return {
      url: productOrVariant.url,
      image: getProductImage(product),
      title: product.title,
      vendor: product.vendor || "",
      price: theme.Currency.formatMoney(product.price_min, theme.moneyFormat),
      compareAtPrice: theme.Currency.formatMoney(
        product.compare_at_price_min,
        theme.moneyFormat
      ),
      available: product.available,
      isOnSale: isOnSale(product),
      isPriceVaries: isPriceVaries(product),
      isCompareVaries: isCompareVaries(product),
    };
  }

  function getProductImage(product) {
    var image;
    var featuredImage;

    if (product.variants.length > 0 && product.variants[0].image !== null) {
      featuredImage = product.variants[0].featured_image;
    } else if (product.image) {
      featuredImage = product.featured_image;
    } else {
      image = null;
    }

    if (image !== null) {
      image = {
        url: theme.Images.getSizedImageUrl(featuredImage.url, "100x"),
        alt: featuredImage.alt,
      };
    }

    return image;
  }

  function isOnSale(product) {
    return (
      product.compare_at_price_min !== null &&
      parseInt(product.compare_at_price_min, 10) >
        parseInt(product.price_min, 10)
    );
  }

  function isPriceVaries(product) {
    return product.price_max !== product.price_min;
  }

  function isCompareVaries(product) {
    return product.compare_at_price_max !== product.compare_at_price_min;
  }

  // Returns the number of optional product details to be shown,
  // values of the detailsList need to be boolean.
  function getDetailsCount() {
    var detailsList = [
      theme.settings.predictiveSearchShowPrice,
      theme.settings.predictiveSearchShowVendor,
    ];

    var detailsCount = detailsList.reduce(function (acc, detail) {
      return acc + (detail ? 1 : 0);
    }, 0);

    return detailsCount;
  }

  function getNumberOfResultsString(resultNumber, resultsCount) {
    return theme.strings.number_of_results
      .replace("[result_number]", resultNumber)
      .replace("[results_count]", resultsCount);
  }

  function _htmlEscape(input) {
    return input
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  return function (data) {
    var products = data.products || [];
    var isLoading = data.isLoading;
    var searchQuery = data.searchQuery || "";

    if (isLoading && products.length === 0) {
      return loadingState();
    }

    return renderResults(products, isLoading, searchQuery);
  };
})();

window.theme = window.theme || {};

(function () {
  // (a11y) This function will be used by the Predictive Search Component
  // to announce the number of search results
  function numberOfResultsTemplateFct(data) {
    if (data.products.length === 1) {
      return theme.strings.one_result_found;
    } else {
      return theme.strings.number_of_results_found.replace(
        "[results_count]",
        data.products.length
      );
    }
  }

  // (a11y) This function will be used by the Predictive Search Component
  // to announce that it's loading results
  function loadingResultsMessageTemplateFct() {
    return theme.strings.loading;
  }

  function isPredictiveSearchSupported() {
    var shopifyFeatures = JSON.parse(
      document.getElementById("shopify-features").textContent
    );

    return shopifyFeatures.predictiveSearch;
  }

  function isPredictiveSearchEnabled() {
    return window.theme.settings.predictiveSearchEnabled;
  }

  function canInitializePredictiveSearch() {
    return isPredictiveSearchSupported() && isPredictiveSearchEnabled();
  }

  // listen for search submits and validate query
  function validateSearchHandler(searchEl, submitEl) {
    submitEl.addEventListener(
      "click",
      validateSearchInput.bind(this, searchEl)
    );
  }

  // if there is nothing in the search field, prevent submit
  function validateSearchInput(searchEl, evt) {
    var isInputValueEmpty = searchEl.value.trim().length === 0;
    if (!isInputValueEmpty) {
      return;
    }

    if (typeof evt !== "undefined") {
      evt.preventDefault();
    }

    searchEl.focus();
  }

  window.theme.SearchPage = (function () {
    var selectors = {
      searchReset: "[data-search-page-predictive-search-clear]",
      searchInput: "[data-search-page-predictive-search-input]",
      searchSubmit: "[data-search-page-predictive-search-submit]",
      searchResults: '[data-predictive-search-mount="default"]',
    };

    var componentInstance;

    function init(config) {
      var searchInput = document.querySelector(selectors.searchInput);
      var searchSubmit = document.querySelector(selectors.searchSubmit);
      var searchUrl = searchInput.dataset.baseUrl;

      componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
        selectors: {
          input: selectors.searchInput,
          reset: selectors.searchReset,
          result: selectors.searchResults,
        },
        searchUrl: searchUrl,
        resultTemplateFct: window.theme.SearchResultsTemplate,
        numberOfResultsTemplateFct: numberOfResultsTemplateFct,
        loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
        onOpen: function (nodes) {
          if (config.isTabletAndUp) {
            return;
          }

          var searchInputBoundingRect = searchInput.getBoundingClientRect();
          var bodyHeight = document.body.offsetHeight;
          var offset = 50;
          var resultsMaxHeight =
            bodyHeight - searchInputBoundingRect.bottom - offset;

          nodes.result.style.maxHeight = resultsMaxHeight + "px";
        },
        onBeforeDestroy: function (nodes) {
          // If the viewport width changes from mobile to tablet
          // reset the top position of the results
          nodes.result.style.maxHeight = "";
        },
      });

      validateSearchHandler(searchInput, searchSubmit);
    }

    function unload() {
      if (!componentInstance) {
        return;
      }
      componentInstance.destroy();
      componentInstance = null;
    }

    return {
      init: init,
      unload: unload,
    };
  })();

  window.theme.SearchHeader = (function () {
    var selectors = {
      searchInput: "[data-predictive-search-drawer-input]",
      searchResults: '[data-predictive-search-mount="drawer"]',
      searchFormContainer: "[data-search-form-container]",
      searchSubmit: "[data-search-form-submit]",
    };

    var componentInstance;

    function init(config) {
      var searchInput = document.querySelector(selectors.searchInput);
      var searchSubmit = document.querySelector(selectors.searchSubmit);
      var searchUrl = searchInput.dataset.baseUrl;

      componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
        selectors: {
          input: selectors.searchInput,
          result: selectors.searchResults,
        },
        searchUrl: searchUrl,
        resultTemplateFct: window.theme.SearchResultsTemplate,
        numberOfResultsTemplateFct: numberOfResultsTemplateFct,
        numberOfResults: config.numberOfResults,
        loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
        onInputBlur: function () {
          return false;
        },
        onOpen: function (nodes) {
          var searchInputBoundingRect = searchInput.getBoundingClientRect();

          // For tablet screens and up, stop the scroll area from extending past
          // the bottom of the screen because we're locking the body scroll
          var maxHeight =
            window.innerHeight -
            searchInputBoundingRect.bottom -
            (config.isTabletAndUp ? 20 : 0);

          nodes.result.style.top = config.isTabletAndUp
            ? ""
            : searchInputBoundingRect.bottom + "px";
          nodes.result.style.maxHeight = maxHeight + "px";
        },
        onClose: function (nodes) {
          nodes.result.style.maxHeight = "";
        },
        onBeforeDestroy: function (nodes) {
          // If the viewport width changes from mobile to tablet
          // reset the top position of the results
          nodes.result.style.top = "";
        },
      });

      validateSearchHandler(searchInput, searchSubmit);
    }

    function unload() {
      if (!componentInstance) {
        return;
      }

      componentInstance.destroy();
      componentInstance = null;
    }

    function clearAndClose() {
      if (!componentInstance) {
        return;
      }

      componentInstance.clearAndClose();
    }

    return {
      init: init,
      unload: unload,
      clearAndClose: clearAndClose,
    };
  })();

  window.theme.Search = (function () {
    var classes = {
      searchTemplate: "template-search",
    };
    var selectors = {
      siteHeader: ".site-header",
    };
    var mediaQueryList = {
      mobile: window.matchMedia("(max-width: 749px)"),
      tabletAndUp: window.matchMedia("(min-width: 750px)"),
    };

    function init() {
      if (!document.querySelector(selectors.siteHeader)) {
        return;
      }

      if (!canInitializePredictiveSearch()) {
        return;
      }

      Object.keys(mediaQueryList).forEach(function (device) {
        mediaQueryList[device].addListener(initSearchAccordingToViewport);
      });

      initSearchAccordingToViewport();
    }

    function initSearchAccordingToViewport() {
      theme.SearchDrawer.close();
      theme.SearchHeader.unload();
      theme.SearchPage.unload();

      if (mediaQueryList.mobile.matches) {
        theme.SearchHeader.init({
          numberOfResults: 4,
          isTabletAndUp: false,
        });

        if (isSearchPage()) {
          theme.SearchPage.init({ isTabletAndUp: false });
        }
      } else {
        // Tablet and up
        theme.SearchHeader.init({
          numberOfResults: 4,
          isTabletAndUp: true,
        });

        if (isSearchPage()) {
          theme.SearchPage.init({ isTabletAndUp: true });
        }
      }
    }

    function isSearchPage() {
      return document.body.classList.contains(classes.searchTemplate);
    }

    function unload() {
      theme.SearchHeader.unload();
      theme.SearchPage.unload();
    }

    return {
      init: init,
      unload: unload,
    };
  })();
})();

window.theme = window.theme || {};

theme.SearchDrawer = (function () {
  var selectors = {
    headerSection: "[data-header-section]",
    drawer: "[data-predictive-search-drawer]",
    drawerOpenButton: "[data-predictive-search-open-drawer]",
    headerSearchInput: "[data-predictive-search-drawer-input]",
    predictiveSearchWrapper: '[data-predictive-search-mount="drawer"]',
  };

  var drawerInstance;

  function init() {
    setAccessibilityProps();

    drawerInstance = new theme.Drawers("SearchDrawer", "top", {
      onDrawerOpen: function () {
        setHeight();
        lockBodyScroll();
      },
      onDrawerClose: function () {
        theme.SearchHeader.clearAndClose();
        var drawerOpenButton = document.querySelector(
          selectors.drawerOpenButton
        );

        if (drawerOpenButton) drawerOpenButton.focus();

        unlockBodyScroll();
      },
      withPredictiveSearch: true,
      elementToFocusOnOpen: document.querySelector(selectors.headerSearchInput),
    });
  }

  function setAccessibilityProps() {
    var drawerOpenButton = document.querySelector(selectors.drawerOpenButton);

    if (drawerOpenButton) {
      drawerOpenButton.setAttribute("aria-controls", "SearchDrawer");
      drawerOpenButton.setAttribute("aria-expanded", "false");
      drawerOpenButton.setAttribute("aria-controls", "dialog");
    }
  }

  function setHeight() {
    var searchDrawer = document.querySelector(selectors.drawer);
    var headerHeight = document.querySelector(
      selectors.headerSection
    ).offsetHeight;

    searchDrawer.style.height = headerHeight + "px";
  }

  function close() {
    drawerInstance.close();
  }

  function lockBodyScroll() {
    theme.Helpers.enableScrollLock();
  }

  function unlockBodyScroll() {
    theme.Helpers.disableScrollLock();
  }

  return {
    init: init,
    close: close,
  };
})();

window.theme = window.theme || {};

/* ================ TEMPLATES ================ */
(function () {
  var filterBys = document.querySelectorAll("[data-blog-tag-filter]");

  if (!filterBys.length) return;

  slate.utils.resizeSelects(filterBys);

  filterBys.forEach(function (filterBy) {
    filterBy.addEventListener("change", function (evt) {
      location.href = evt.target.value;
    });
  });
})();

/*================ SECTIONS ================*/

window.theme = window.theme || {};

theme.HeaderSection = (function () {
  function Header() {
    theme.SearchDrawer.init();
    theme.Search.init();
  }

  Header.prototype = Object.assign({}, Header.prototype, {
    onUnload: function () {
      theme.Search.unload();
    },
  });

  return Header;
})();

document.addEventListener("DOMContentLoaded", function () {
  var sections = new theme.Sections();
  sections.register("product", theme.Product);
  sections.register("product-template", theme.Product);
  sections.register("header-section", theme.HeaderSection);

  document.querySelectorAll('a[href="#"]').forEach(function (anchor) {
    anchor.addEventListener("click", function (evt) {
      evt.preventDefault();
    });
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal,
    },
    links: document.querySelectorAll(
      "a[href]:not([aria-describedby]), .product-single__thumbnail"
    ),
  });

  // Initialize form status
  theme.FormStatus.init();

  var selectors = {
    image: "[data-image]",
    lazyloaded: ".lazyloaded",
  };

  document.addEventListener("lazyloaded", function (evt) {
    var image = evt.target;

    removeImageLoadingAnimation(image);

    if (document.body.classList.contains("template-index")) {
      var mainContent = document.getElementById("MainContent");

      if (mainContent && mainContent.children && mainContent.children.length) {
        var firstSection = document.getElementsByClassName("index-section")[0];

        if (!firstSection.contains(image)) return;

        window.performance.mark("debut:index:first_image_visible");
      }
    }

    if (image.hasAttribute("data-bgset")) {
      var innerImage = image.querySelector(selectors.lazyloaded);

      if (innerImage) {
        var alt = image.getAttribute("data-alt");
        var src = innerImage.hasAttribute("data-src")
          ? innerImage.getAttribute("data-src")
          : image.getAttribute("data-bg");

        image.setAttribute("alt", alt ? alt : "");
        image.setAttribute("src", src ? src : "");
      }
    }

    if (!image.hasAttribute("data-image")) {
      return;
    }
  });

  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  function onLoadHideLazysizesAnimation() {
    var alreadyLazyloaded = document.querySelectorAll(".lazyloaded");
    alreadyLazyloaded.forEach(function (image) {
      removeImageLoadingAnimation(image);
    });
  }

  onLoadHideLazysizesAnimation();

  document.addEventListener(
    "touchstart",
    function () {
      theme.Helpers.setTouch();
    },
    { once: true }
  );

  if (document.fonts) {
    document.fonts.ready.then(function () {
      window.performance.mark("debut:fonts_loaded");
    });
  }
});

function removeImageLoadingAnimation(image) {
  // Remove loading animation
  var imageWrapper = image.hasAttribute("data-image-loading-animation")
    ? image
    : image.closest("[data-image-loading-animation]");

  if (imageWrapper) {
    imageWrapper.removeAttribute("data-image-loading-animation");
  }
}

$(document).ready(function () {
  // var $ = jQuery.noConflict();
  // Currency price changer
  $(".currency_switcher-selector .init").on("click", function () {
    $(this).siblings("ul.list-unstyled").toggleClass("open");
    $(this).toggleClass("active");
  });
  var allOptions = $("ul.list-unstyled").children("li");
  $("ul.list-unstyled").on("click", "li", function () {
    var redirect_URL = $(this).data("redirect");
    allOptions.removeClass("selected");
    $(this).addClass("selected");
    $(".currency_switcher-selector").children(".init").html($(this).html());
    $(".currency_switcher-selector")
      .children(".init")
      .attr("data-value", $(this).data("value"));
    window.location.href = redirect_URL;
    allOptions.toggle();
  });

  // Shipping Delivery calculation
  var calculator = {
    workDaysAdded: 0,
    month: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ],
    monthFull: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    weekday: ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"],
    weekdayFull: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    ukHolidays: ["2024-11-28","2024-12-25",  "2025-01-01"], //"2023-05-23", "2023-05-24"
    startDate: null,
    curDate: null,

    addWorkDay: function () {
      this.curDate.setDate(this.curDate.getDate() + 1);
      if (
        this.ukHolidays.indexOf(this.formatDate(this.curDate)) === -1 &&
        this.curDate.getDay() !== 0 &&
        this.curDate.getDay() !== 6
      ) {
        this.workDaysAdded++;
      }
    },

    formatDate: function (date) {
      var day = date.getDate(),
        month = date.getMonth() + 1;

      month = month > 9 ? month : "0" + month;
      day = day > 9 ? day : "0" + day;
      return date.getFullYear() + "-" + month + "-" + day;
    },

    getNewWorkDay: function (daysToAdd) {
      this.startDate = new Date();
      //console.log(this.startDate,new Date(this.startDate.toLocaleString('en-US', { timeZone: 'America/New_York' })),new Date(this.startDate.toLocaleString('en-US', { timeZone: 'America/Chicago' })));
      this.curDate = new Date(this.startDate.toLocaleString('en-US', { timeZone: 'America/New_York' }));
      this.workDaysAdded = 0;

      while (this.workDaysAdded < daysToAdd) {
        this.addWorkDay();
      }
      return [
        this.weekday[this.curDate.getDay()],
        this.month[this.curDate.getMonth()],
        this.curDate.getDate(),
        this.weekdayFull[this.curDate.getDay()],
        this.monthFull[this.curDate.getMonth()],
      ];
    },
  };

  function shipping_work_day(day) {
    var newWorkDay = calculator.getNewWorkDay(day);
    $(".product-form_ship-in-ring-timeline b").text(`${newWorkDay[0]}, ${newWorkDay[1]} ${newWorkDay[2]}`);
    $(".product-form__item--submit #properties-ship-by").val(`${newWorkDay[3]}, ${newWorkDay[4]} ${newWorkDay[2]}`);
    $(".product-form__item--submit #properties-ship-in").val(`${day}`);
    // $(".pdp-get-in-time").removeClass("hide");
    // if(day < 5){
    //   $(".pdp-get-in-time").removeClass("hide");
    // }else{
    //   $(".pdp-get-in-time").addClass("hide");
    // }
    // if(newWorkDay[1] == "April" && newWorkDay[2] <= 30){
    //   $(".pdp-get-in-time").removeClass("hide");
    // } else {
    //   if (newWorkDay[1] == "May" && newWorkDay[2] <= 1) {
    //     $(".pdp-get-in-time").removeClass("hide");
    //   } else {
    //     $(".pdp-get-in-time").addClass("hide");
    //   }
    // }
  }
  shipping_work_day(8);
  // Product page css
  var productPage = {
    windowWidth: $(window).width(),
    updateManualDiscount: function () {
      try {
        if (theme.windowUrl.indexOf("view=final-ring") > -1) {
          return false;
        }
        var isVariantDiscountAvailable = false,
          discount;
        var selected_option = $('[name="id"]').children("option:selected");
        const variant_metafield_sting = $("#product_variant-json").text();
        if (variant_metafield_sting) {
          variant_metafield_obj = JSON.parse($("#product_variant-json").text());
        }
        const variantID = selected_option.val();
        const current_variant_metafield = variant_metafield_obj[variantID];
        console.log(
          "current_variant_metafield",
          current_variant_metafield,
          variantID
        );
        for (const [key, value] of Object.entries(current_variant_metafield)) {
          if (key == "variant_discounts") {
            discount = value;
            isVariantDiscountAvailable = true;
          }
          break;
        }
        try {
          var saleSign = $(".sale-signin");
          if (!discount) {
            saleSign && saleSign.hide();
          } else {
            saleSign && saleSign.show();
          }
        } catch (e) {
          console.log(e);
        }
        var isCustomer = theme.customer;
        if (isCustomer && isVariantDiscountAvailable && discount) {
          var variantPriceWithoutCurrency = parseInt(
            selected_option.data("price-without-currency")
          );
          var selling_price =
            variantPriceWithoutCurrency * (1 - parseInt(discount) / 100);
          setTimeout(function () {
            $(".prodcut__price").addClass("price--on-sale");
            $(".price__on-sale").text(
              theme.Currency.formatMoney(selling_price, theme.moneyFormat)
            );
            $(".price__regular").text(
              theme.Currency.formatMoney(
                variantPriceWithoutCurrency,
                theme.moneyFormat
              )
            );
            $(".precentage_off").text(`(${theme.Currency.formatMoney(variantPriceWithoutCurrency - selling_price, theme.moneyFormat)} OFF)`);
          }, 0);
        }
      } catch (e) {
        console.log(e);
      }
    },
    variant_metafield_update: function (selected_option) {
      const variant_metafield_sting = $("#product_variant-json").text();
      try {
        let variant_metafield_obj;
        if (variant_metafield_sting) {
          variant_metafield_obj = JSON.parse($("#product_variant-json").text());
        }
        const variantID = selected_option.val();
        const current_variant_metafield = variant_metafield_obj[variantID];
        $(".variant-metafield").hide();
        var diamond_total_weight = $(
            ".swatch-total-carat-weight input:checked"
          ).val(),
          diamond_center_weight,
          diamond_shape,
          variant_meta_title,
          variant_meta_desc;
        for (const [key, value] of Object.entries(current_variant_metafield)) {
          // console.log(`${key}: ${value}`);
          if (value != null) {
            $(`.${key}`).show();
          }
          $(`.${key} .meta-info-desc`).text(`${value}`);
          if (key.indexOf("variant-diamond-weight") > -1) {
            diamond_center_weight = value;
          }
          if (key.indexOf("variant-center-diamond-shape") > -1) {
            diamond_shape = value;
          }
          if (key.indexOf("variant-meta-title") > -1) {
            variant_meta_title = value;
          }
          if (key.indexOf("variant-meta-desc") > -1) {
            variant_meta_desc = value;
          }
          if (key.indexOf("variant-description") > -1) {
            var variant_description = value;
            if(variant_description && variant_description.length){
              $(".product-variant-content p").text(variant_description);
              $(".product-variant-content").show();
              $(".product-description-content").hide();
            }else{
              $(".product-variant-content").hide();
              $(".product-description-content").show();
            }
          }
        }
        // Code to change Ring settings meta title and description
        var windowLocation = window.location.href;
        if (
          theme.product.type == "engagement-ring" &&
          windowLocation.indexOf("&view=final") < 0
        ) {
          var product_title = $(".product-single__title").text();
          var ring_setting_color = $(
            ".swatch-metal-color input:checked + label"
          ).data("colorname");
          var ring_setting_shape = $(
            ".swatch-shape input:checked + label"
          ).data("colorname");
          // Change page title
          document.title = `${product_title} with ${ring_setting_shape} Cut Diamond in ${ring_setting_color} | With Clarity`;
          // Change meta description
          var metaDesc = document.querySelector('meta[name="description"]');
          if (metaDesc) {
            metaDesc.setAttribute(
              "content",
              `Shop ${product_title} with ${ring_setting_shape} Cut Diamond in ${ring_setting_color} online. Enjoy Free Delivery & Hassle Free Returns.`
            );
          }
        }
        // code to change preset title and diamond details on variant change
        if (
          theme.product.type == "preset-ring" ||
          theme.product.type == "quick-ship-engagement-ring"
        ) {
          $(".preset-center-diamond-title").text(
            `${diamond_center_weight}. Igi certified center diamond`
          );
          if (theme.product.type == "preset-ring") {
            if (
              theme.product.tags.indexOf("the-reserve") > -1 ||
              theme.product.tags.indexOf("luxe") > -1
            ) {
              return false;
            }
            var product_title = $(".product-single__title").data("title");
            $(".product-single__title").text(
              `${diamond_total_weight} cttw  ${diamond_shape} Cut ${product_title}`
            );
          }
        }
        if (theme.product.tags.indexOf("nfl") > -1) {
          var product_title = $(".product-single__title")
            .data("title")
            .split("NFL");
          var variant_title = $("#ProductSelect-product-template")
            .find("option:selected")
            .text()
            .split(" / ")[2];
          $(".product-single__title").text(
            `NFL  ${variant_title} ${product_title[1]}`
          );
        }
        // Change page title
        if (variant_meta_title) {
          document.title = variant_meta_title;
        }
        // Change meta description
        if (variant_meta_desc) {
          var metaDesc = document.querySelector('meta[name="description"]');
          if (metaDesc) {
            metaDesc.setAttribute("content", variant_meta_desc);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    variantShippingMsgChange: function (selected_option) {
      // Update variant image
      var variantMainImage = selected_option.data("variant-main-img");
      $("#properties-product-image").val(variantMainImage);

      var selected_option_text = $.trim(selected_option.text());
      // productPage.handleRecommendedPresetDiamond(selected_option);
      productPage.hideUnavailableOption(
        selected_option_text.split(" / ")[1],
        selected_option_text.split(" / ")[2]
      );
      productPage.variant_metafield_update(selected_option);
      const variant_policy = selected_option.data("variant-policy");
      const variant_quantity = parseInt(
        selected_option.data("variant-quantity")
      );
      if (theme.product.tags.indexOf("product-ships-in-12") > -1) {
        shipping_work_day(12);
        return false;
      }
      if (theme.product.tags.indexOf("quick-ship-product") > -1) {
        if (variant_quantity > 0) {
          shipping_work_day(4);
        } else {
          shipping_work_day(8);
        }
      } else if (theme.product.tags.indexOf("ny-quick-ship") > -1) {
        if (variant_quantity > 0) {
          shipping_work_day(2);
        } else {
          shipping_work_day(8);
        }
      } else if (theme.product.tags.indexOf("india-quick-ship") > -1) {
        if (variant_quantity > 0) {
          shipping_work_day(4);
        } else {
          shipping_work_day(8);
        }
      } else if (
        variant_quantity > 0 &&
        theme.product.type.indexOf("earrings") > -1
      ) {
        shipping_work_day(2);
      } else if (
        theme.product.type.indexOf("quick-ship-engagement-ring") > -1
      ) {
        shipping_work_day(4);
      } else if (theme.product.type == "home-preview") {
        shipping_work_day(10);
      } else if (theme.product.tags.indexOf("ships-by-15-may") > -1) {
        $(".product-form_ship-in-ring-timeline b").text(`Wed, May 15`);
        $(".product-form__item--submit #properties-ship-by").val(`Wed, May 15`);
        $(".product-form__item--submit #properties-ship-in").val(`30`);
        return false;
      } else if (theme.product.tags.indexOf("the-reserve") > -1) {
        variant_quantity > 0 ? shipping_work_day(2) : shipping_work_day(8);
      } else {
        shipping_work_day(8);
      }
    },
    mobileImageSlider: function () {
      // return false;
      if (theme.windowUrl.indexOf("view=final") > -1 || theme.windowUrl.indexOf("/products/final-ring") > -1) {
        if (productPage.windowWidth > 767) {
          return false;
        }
        var product_single__media = $(".product-single__media-group");
        if (product_single__media.length) {
          product_single__media.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            responsive: [
              {
                breakpoint: 749,
                settings: {
                  arrows: true,
                  dots: true,
                },
              },
            ],
          });
        }
        return false;
      }
      // if (
      //   theme.product.tags.indexOf("luxury-engagement-rings") > -1 &&
      //   productPage.windowWidth > 767
      // ) {
      //   return false;
      // }
      var product_single__media = $(".product-single__media-group");
      var product_single__thumbnails = $(".product-media__thumbnails");
      if (product_single__media.length) {
        var product_single__media_slider = product_single__media.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 749,
              settings: {
                arrows: true,
                dots: true,
              },
            },
          ],
        });
        product_single__media_slider.on('afterChange', function(event, slick, currentSlide){
          productPage.playSliderVideoOnChange($('.product-single__media-group'));
        });
      }

      if (
        product_single__thumbnails.length &&
        product_single__thumbnails.is(":visible")
      ) {
        product_single__thumbnails.slick({
          slidesToShow: 6,
          slidesToScroll: 1,
          vertical: true,
          verticalSwiping: true,
          arrows: true,
          dots: false,
          infinite: false,
        });
        product_single__thumbnails
          .find("div[data-slick-index]")
          .on("click", function () {
            $(this).addClass("active").siblings().removeClass("active");
            if (product_single__thumbnails.hasClass("slick-slider")) {
              var slideno = $(this).data("slick-index");
              console.log(slideno);
              product_single__media.slick("slickGoTo", slideno);
            } else {
              var slideno = $(this).data("slide");
              product_single__media.slick("slickGoTo", slideno - 1);
            }
          });
      }
    },
    playSliderVideoOnChange: function(selector){
      selector.find('.slick-slide video').each(function () {
        this.pause();
      });
      const $activeSlide = selector.find('.slick-active');
      const $video = $activeSlide.find('video');
      if ($video.length) {
        $video[0].play();
      }
    },
    changeMobileSliderImage: function (variantHandle) {
      var product_single__media = $(".product-single__media-group");
      var product_single__thumbnails = $(".product-media__thumbnails");
      if (theme.windowUrl.indexOf("view=final") > -1) {
        return false;
      }
      // if (
      //   theme.product.tags.indexOf("luxury-engagement-rings") > -1 &&
      //   productPage.windowWidth > 767
      // ) {
      //   return false;
      // }
      if (product_single__media.length) {
        product_single__media.slick("slickUnfilter");
        product_single__media.slick(
          "slickFilter",
          `.product-single__media-wrapper.all,.${variantHandle}`
        );
        $(".product-single__media-wrapper").removeClass("hide");
        productPage.playSliderVideoOnChange($('.product-single__media-group'));
      }
      if (
        product_single__thumbnails.length &&
        product_single__thumbnails.is(":visible")
      ) {
        product_single__thumbnails.slick("slickUnfilter");
        product_single__thumbnails
          .slick(
            "slickFilter",
            `.product-thumbnil__media-wrapper.all,.${variantHandle}`
          )
          .slick("refresh");
        product_single__thumbnails.slick("setPosition");
        $(".product-thumbnil__media-wrapper").removeClass("hide");
      }
    },
    changeModelImagePosition: function (activProductImage) {
      try {
        productPage.changeMobileSliderImage(activProductImage);
        if (productPage.windowWidth < 768) {
          return false;
        }
        if (!activProductImage) {
          return false;
        }
        let currentOrder = 0;
        $(".product-single__media-group ." + activProductImage).each(function (
          index
        ) {
          currentOrder = index;
          $(this).addClass(`image-full-width-${index}`).css({ order: index });
        });
        if (
          activProductImage.indexOf("white-rose") > -1 ||
          activProductImage.indexOf("white-yellow") > -1
        ) {
          if (activProductImage.indexOf("white-rose") > -1) {
            $(".white-rose-perspectiveview").css({ order: currentOrder + 1 });
          }
          if (activProductImage.indexOf("white-yellow") > -1) {
            $(".white-yellow-perspectiveview").css({ order: currentOrder + 1 });
          }
        } else {
          if (activProductImage.indexOf("rose") > -1) {
            $(".rose-perspectiveview").css({ order: currentOrder + 1 });
          }
          if (activProductImage.indexOf("yellow") > -1) {
            $(".yellow-perspectiveview").css({ order: currentOrder + 1 });
          }
          if (activProductImage.indexOf("white") > -1) {
            $(".white-perspectiveview").css({ order: currentOrder + 1 });
          }
        }

        $(".all:not(.model-image)").each(function () {
          $(this).css({ order: currentOrder + 2 });
        });
        $(".model-image").each(function (index) {
          if (index == 0 || index == 1) {
            $(this).css({ order: 0 });
          } else {
            $(this).css({ order: 2 });
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    variantImageChange: function (variantHandle) {
      const windowWidth = $(window).width();
      if (productPage.windowWidth < 768) {
        productPage.changeMobileSliderImage(variantHandle);
        return false;
      }
      if (!variantHandle) {
        return false;
      }
      productPage.changeModelImagePosition(variantHandle);

      $(".product-single__media-wrapper").addClass("hide");
      $(".product-single__media-wrapper.all,." + variantHandle).removeClass(
        "hide"
      );
      console.log(variantHandle);
      try {
        if (
          variantHandle.indexOf("white-rose") > -1 ||
          variantHandle.indexOf("white-yellow") > -1
        ) {
          if (variantHandle.indexOf("white-rose") > -1) {
            $(".white-rose-perspectiveview").removeClass("hide");
            return false;
          }
          if (variantHandle.indexOf("white-yellow") > -1) {
            $(".white-yellow-perspectiveview").removeClass("hide");
            return false;
          }
        } else {
          if (variantHandle.indexOf("rose") > -1) {
            $(".rose-perspectiveview").removeClass("hide");
          }
          if (variantHandle.indexOf("yellow") > -1) {
            $(".yellow-perspectiveview").removeClass("hide");
          }
          if (variantHandle.indexOf("white") > -1) {
            $(".white-perspectiveview").removeClass("hide");
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    changeMatchingBandVariant: function (metal_color) {
      try {
        var colorHandle = metal_color.replace(/\s+/g, "-").toLowerCase();
        var $matchingBandOption = $(
          `#matching-band-variant option[data-color-handle="${colorHandle}"]`
        );
        var $matchingBandValue = $matchingBandOption.val();
        // If option is found, set it as selected
        if ($matchingBandValue.length > 0) {
          $("#matching-band-variant").val($matchingBandValue).change();
          var $matchingBandImage = $matchingBandOption.attr("data-image");
          var $matchingBandPrice = $matchingBandOption.attr("data-price");
          var $matchingBandColor = $matchingBandOption.attr("data-color-title");
          $(".matching-product img").attr("srcset", $matchingBandImage);
          $(".matching-product .matching-product-price").text(
            $matchingBandPrice
          );
          $(".matching-product .matching-product-title span").text(
            $matchingBandColor
          );
        }
      } catch (e) {
        console.log(e);
      }
    },
    changeUpSellProduct: function(upSellOption){
      try {
        var upSellOptionValue = upSellOption.val();
        console.log(upSellOptionValue)
        // If option is found, set it as selected
        if (upSellOptionValue.length > 0) {
          var upSellOptionImage = upSellOption.attr("data-image");
          var upSellOptionPrice = upSellOption.attr("data-price");
          var upSellOptionColor = upSellOption.attr("data-color-title");
          return [upSellOptionValue,upSellOptionImage,upSellOptionPrice,upSellOptionColor];
        }
      } catch (e) {
        console.log(e);
      }
    },
    changeMatchingGiftSets: function(metal_color){
      try{
        var colorHandle = metal_color.replace(/\s+/g, "-").toLowerCase();
        var upSellOption = $(
          `#gift-set-variant option[data-color-handle="${colorHandle}"]`
        );
        var [$giftSetValue,$giftSetImage,$giftSetPrice,$giftSetColor] = productPage.changeUpSellProduct(upSellOption);
        $("#gift-set-variant").val($giftSetValue).change();
        $(".pdp-shop-the-set img").attr("srcset", $giftSetImage);
        $(".pdp-shop-the-set .set-product-price").text(
          $giftSetPrice
        );
        $(".pdp-shop-the-set .set-metal-color").text(
          $giftSetColor
        );
        $(".pdp-shop-the-set .set-product-link").attr("href",$(".set-product-link").data("url")+`?variant=${$giftSetValue}`);
      }catch(e){
        console.log(e)
      }
    },
    swatchVariantChange: function () {
      function add_to_cart_button_text(isVariantAvailable) {
        if (isVariantAvailable) {
          if (theme.product.tags.indexOf("ring-setting-product") > -1) {
            $(".product-form__item--submit")
              .find('[name="add"]')
              .removeClass("btn--secondary-accent")
              .attr("aria-label", "Choose this setting")
              .text("Choose this setting");
          } else if (theme.product.type.indexOf("home-preview") > -1) {
            $(".product-form__item--submit")
              .find('[name="add"]')
              .removeClass("btn--secondary-accent")
              .attr("aria-label", "Add to box")
              .text("Add to box");
          } else {
            $(".product-form__item--submit")
              .find('[name="add"]')
              .removeClass("btn--secondary-accent")
              .attr("aria-label", "Add to cart")
              .text("Add to cart");
          }
        } else {
          $(".product-form__item--submit")
            .find('[name="add"]')
            .addClass("btn--secondary-accent")
            .attr("aria-label", "Sold out")
            .text("Sold out");
        }
      }

      $('[name="id"]').on("change", function () {
        var variant = $(this).val();
        var selected_option = $(this).children("option:selected");
        productPage.variantImageChange(selected_option.data("variant-handle"));
        productPage.variantShippingMsgChange(selected_option);
        var variantSku = selected_option.data("sku");
        var isVariantAvailable = selected_option.data("available");
        var variantPriceWithCurrency = selected_option.data("price");
        var variantComparePriceWithCurrency =
          selected_option.data("compare-price");
        var variantPriceWithoutCurrency = parseInt(
          selected_option.data("price-without-currency")
        );
        var variantComparePriceWithoutCurrency = parseInt(
          $(this)
            .children("option:selected")
            .data("compare-price-without-currency")
        );
        productPage.variant_update_protection_price(
          variantPriceWithoutCurrency
        );
        $(".affirm-as-low-as").attr("data-amount", variantPriceWithoutCurrency);
        affirm.ui.refresh();
        $(".price__regular [data-regular-price]").text(
          variantPriceWithCurrency
        );
        if (theme.product.type == "home-preview") {
          $(".prodcut__price [data-sale-price]").text(
            "Refundable Deposit - " + variantPriceWithCurrency
          );
          $(".home-preview-color").text(variantSku.split("/")[1]);
        } else {
          $(".prodcut__price [data-sale-price]").text(variantPriceWithCurrency);
        }
        $(".prodcut__price [data-regular-price],.home-preview-price").text(
          variantComparePriceWithCurrency
        );
        if (
          variantComparePriceWithoutCurrency > variantPriceWithoutCurrency &&
          variantPriceWithoutCurrency != NaN
        ) {
          const percentOff = parseInt(
            ((variantComparePriceWithoutCurrency -
              variantPriceWithoutCurrency) /
              variantComparePriceWithoutCurrency) *
              100
          );
          var amountOff = parseInt(
            (variantComparePriceWithoutCurrency - variantPriceWithoutCurrency) /
              100
          );
          $(".prodcut__price [data-price-precentage]").text(
            `($${amountOff} OFF)`
          );
          $(".prodcut__price").addClass("price--on-sale");
        }
        if (
          variantComparePriceWithoutCurrency < variantPriceWithoutCurrency &&
          variantPriceWithoutCurrency != NaN
        ) {
          $(".prodcut__price").removeClass("price--on-sale");
        }
        $(".product-single__sku span").text(variantSku);
        function variantAvailable() {
          // $(".estimated_date").removeClass("hide");
          add_to_cart_button_text(isVariantAvailable);
          $(".product-form").removeClass("product-form--variant-sold-out");
          // two week function
          // weeks2update(true);
        }
        function variantNotAvailable() {
          // $(".estimated_date").addClass("hide");
          add_to_cart_button_text(isVariantAvailable);
          $(".product-form").addClass("product-form--variant-sold-out");
          // two week function
          // weeks2update(false);
        }
        productPage.variantHeaderName();
        if (isVariantAvailable != undefined) {
          isVariantAvailable == false
            ? variantNotAvailable()
            : variantAvailable();
        }
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          variant;
        window.history.replaceState({ path: newurl }, "", newurl);
        productPage.updateManualDiscount();
      });
      $(".swatch :radio").change(function () {
        var optionIndex = jQuery(this)
          .closest(".swatch")
          .attr("data-option-index");
        var optionValue = jQuery(this).val();
        $(this)
          .closest("form")
          .find(".single-option-selector")
          .eq(optionIndex)
          .val(optionValue)
          .trigger("change");
        var option1 = $('.single-option-selector[data-index="option1"]').val();
        var option2 = $('.single-option-selector[data-index="option2"]').val();
        var option3 = $('.single-option-selector[data-index="option3"]').val();
        productPage.hideUnavailableOption(option2, option3);
        // is banding band is active
        var isWeddingbandActive = $(this)
          .closest(".product-form")
          .find("#wedding-band-checkbox")
          .prop("checked");
        if (isWeddingbandActive) {
          productPage.changeMatchingBandVariant(option1);
        }
        if(theme.product.product_set){
          productPage.changeMatchingGiftSets(option1);
        }
        var metal_color = $(".metal-color").find("select").val();
        var shape_type = $(".shape").find("select").val();
        if (metal_color?.length) {
          productPage.variantNameOnLoad(metal_color, shape_type);
          $(".metal-variant-info").text(metal_color);
        }
        var finalOption;
        if (option2 != undefined && option3 != undefined) {
          finalOption = option1 + " / " + option2 + " / " + option3;
        } else if (option2 != undefined) {
          finalOption = option1 + " / " + option2;
        } else {
          finalOption = option1;
        }
        var valofText = $('[name="id"] option')
          .filter(function () {
            return this.text == finalOption;
          })
          .val();

        var variantMetalName = $(
          ".swatch.metal .swatch-element input:checked + label"
        ).attr("data-colorname");
        $(".header .metalName").text(variantMetalName);
        console.log(valofText);
        $('[name="id"]').val(valofText).change();
      });
    },
    hideUnavailableOption: function (option2 = "", option3 = "") {
      console.log("a");
      try {
        // var product_tags = theme.product.tags;
        // if (product_tags.indexOf("multi-option-variant") < 0) {
        //   return false;
        // }
        if (!option2.length) {
          return false;
        }
        var first_option = $(`[data-option-index="0"]`)
          .find("input:checked")
          .closest(".swatch-element")
          .data("value");
        var option2 = [];
        var option3 = [];
        $('[name="id"] option').each(function () {
          var data_value = $.trim($(this).text());
          if (data_value.indexOf(first_option) > -1) {
            var optionValue2 = data_value.split(" / ")[1];
            option2.push(optionValue2);
            var optionValue3 = data_value.split(" / ")[2];
            option3.push(optionValue3);
          }
        });
        option2 = [...new Set(option2)];
        option3 = [...new Set(option3)];
        var option2String = option2.join(",");
        var option3String = option3.join(",");
        var option_2_selected_value = $(
          `[data-option-index="1"] input:checked`
        ).val();
        var option_3_selected_value = $(
          `[data-option-index="2"] input:checked`
        ).val();
        // console.log(
        //   "hideUnavailableOption",
        //   option_2_selected_value,
        //   option_3_selected_value,
        //   option2[0]
        // );
        $(`[data-option-index="1"]`)
          .find(".swatch-element")
          .each(function () {
            var swatchValue = $(this).data("value");
            if (option2String.indexOf(swatchValue) > -1) {
              $(this).removeClass("unavailable");
            } else {
              $(this).addClass("unavailable");
            }
          });
        if (option3.length) {
          $(`[data-option-index="2"]`)
            .find(".swatch-element")
            .each(function () {
              var swatchValue = $(this).data("value");
              if (option3String.indexOf(swatchValue) > -1) {
                $(this).removeClass("unavailable");
              } else {
                $(this).addClass("unavailable");
              }
            });
        }
        setTimeout(function () {
          if (option2String.indexOf(option_2_selected_value) < 0) {
            $(
              `[data-option-index="1"] [data-value="${option2[0]}"] label`
            ).trigger("click");
          }
          if (option3String.indexOf(option_3_selected_value) < 0) {
            $(
              `[data-option-index="2"] [data-value="${option3[0]}"] label`
            ).trigger("click");
          }
        }, 0);
      } catch (error) {
        console.log(error);
      }
    },
    accordion: function () {
      $(".accordion-header.active").next().stop().slideDown();
      $(".accordion-header").on("click", function () {
        var closestParent = $(this).closest(".product_description--accordion");
        var next_sibling = $(this).next();
        closestParent
          .find(".accordion-content")
          .not(next_sibling)
          .stop()
          .slideUp();
        closestParent.find(".accordion-header").not(this).removeClass("active");
        $(this).toggleClass("active").next().stop().slideToggle();
      });
    },
    variantHeaderName: function () {
      $(".swatch.header span").text("");
      var variant_name = $(".product-form__variants")
        .find(":selected")
        .text()
        .split(" / ");
      if (variant_name[0]) {
        $(
          '.swatch[data-option-index="0"] .header span:not(.custom-swatch-name)'
        )
          .attr("data-name", variant_name[0])
          .text(variant_name[0]);
      }
      if (variant_name[1]) {
        $(
          '.swatch[data-option-index="1"] .header span:not(.custom-swatch-name)'
        )
          .attr("data-name", variant_name[1])
          .text(variant_name[1]);
      }
      if (variant_name[2]) {
        $(
          '.swatch[data-option-index="2"] .header span:not(.custom-swatch-name)'
        )
          .attr("data-name", variant_name[2])
          .text(variant_name[2]);
      }
      // on hover code
      $(".swatch-element")
        .mouseenter(function () {
          var variant_name = $(this).data("value");
          $(this).closest(".swatch").find(".header span").text(variant_name);
        })
        .mouseleave(function () {
          var variant_name = $(this)
            .closest(".swatch")
            .find(".header span")
            .attr("data-name");
          $(this).closest(".swatch").find(".header span").text(variant_name);
        });
    },
    variantNameOnLoad: function (metal_color, shape_type) {
      // console.log(
      //   metal_color,
      //   shape_type,
      //   $(".metal-color").find("select").val()
      // );
      var metal_color = metal_color || $(".metal-color").find("select").val();
      $(".metal-variant-info").text(metal_color);

      // Code to add extra class metal color swatch parent to remove absolute position
      var metal_color_length =
        $(".swatch-metal-color") &&
        $(".swatch-metal-color .swtach-label-wrapper > div").length;
      if (metal_color_length == 1) {
        $(".swatch-metal-color").addClass("swatch-single-metal-variant");
      }
    },
    carat_option_select_on_load: function () {
      const carat_weight = $(
        ".total-carat-weight .single-option-selector"
      ).val();
      // console.log(carat_weight);
      $(`[data-value="${carat_weight}"] input`).prop("checked", true);
    },
    home_preview_ajax_add_to_cart: function (variant_id, _this, carat_size) {
      const home_preview = {
        id: variant_id,
        quantity: 1,
        properties: {},
      };
      home_preview.properties["_Product Type"] = "Home Preview";
      home_preview.properties["_Product Image"] = $('[name="id"]')
        .children("option:selected")
        .data("variant-main-img");
      home_preview.properties["Carat Size"] = $(
        ".swatch-total-carat-weight input:checked"
      ).val();
      home_preview.properties["Size"] = $('#product-single__ring-size').val();
      axios
        .post(`/cart/add.js`, home_preview)
        .then(({ data }) => {
          $("body").addClass("show-website-popup");
          $("#home-preview-popup").addClass("show-popup-content");
          _this.removeClass("button-active disabled");
          $.get("/cart?view=ajax", function (cart) {
            var CartCount = $($.parseHTML(cart))
              .find(".cart__products")
              .data("count");
            console.log(CartCount);
            $("#CartCount").removeClass("hide");
            $("[data-cart-count]").html(CartCount);
          });
        })
        .catch((err) => {
          console.log(err);
          hide_loading_icon(_this);
        });
    },
    buyNowSettingEvent: function () {
      $("#select-setting-only-popup button").on("click", function () {
        var $this = $(this);
        var variant_id = $('.product-form [name="id"]').val();
        var ring_size_selector = $("#popup-ring-size");
        var ring_engraving = $("#popup-ring-engraving").val();
        var diamond_type_selector = $("#popup-diamond-type");
        var diamond_shape = $("#popup-ring-shape").val();
        var diamond_carat = $("#popup-ring-carat").val();
        var diamond_dimension = $("#popup-ring-dimension").val();
        $this.addClass("button-active disabled");
        if (
          ring_size_selector.val().length < 1 ||
          diamond_type_selector.val().length < 1
        ) {
          if (ring_size_selector.val().length < 1) {
            $("#popup-ring-size + .error-msg").show();
            $this.removeClass("button-active disabled");
          }
          if (diamond_type_selector.val().length < 1) {
            $("#popup-diamond-type + .error-msg").show();
            $this.removeClass("button-active disabled");
          }
        } else {
          $("#select-setting-only-popup .error-msg").hide();
          const ring_setting = {
            id: variant_id,
            quantity: 1,
            properties: {},
          };
          ring_setting.properties["_Ship By"] = $("#properties-ship-by").val();
          ring_setting.properties["Size"] = ring_size_selector.val();
          ring_setting.properties["Type"] = diamond_type_selector.val();
          ring_setting.properties["_Ship In"] = $("#properties-ship-in").val();
          ring_setting.properties["_Product Type"] = "Engagement Ring";
          if (ring_engraving.length > 0) {
            ring_setting.properties["Engraving text"] = ring_engraving;
          }
          if (diamond_shape.length > 0) {
            ring_setting.properties["Diamond shape"] = diamond_shape;
          }
          if (diamond_carat.length > 0) {
            ring_setting.properties["Diamond carat weight"] = diamond_carat;
          }
          if (diamond_dimension.length > 0) {
            ring_setting.properties["Diamond dimension"] = diamond_dimension;
          }
          axios
            .post(`/cart/add.js`, ring_setting)
            .then(({ data }) => {
              $this.removeClass("button-active disabled");
              window.location.href = "/cart";
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
      // Hide error msg
      $("#select-setting-only-popup select").change(function () {
        $(this).closest(".relative-div").find(".error-msg").hide();
      });
      $("#popup-diamond-type").change(function () {
        var value = $(this).val();
        if (value == "Natural") {
          $(".natural-daimond-msg").show();
        } else {
          $(".natural-daimond-msg").hide();
        }
      });
    },
    scorllToDivInMobile: function (selector, error_selector) {
      const window_width = $(window).width();
      if (window_width < 768) {
        $("html, body").animate({
          scrollTop: selector.position().top,
        });
        $(".product-form__add-to-cart-wrapper .error-msg").show();
      }
    },
    protection_product_info: function (
      protection,
      timestamp,
      active_protection_plan
    ) {
      var protection_varaint_id = active_protection_plan
        .closest(".grid__item")
        .attr("data-protection-id");
      protection.id = protection_varaint_id;
      protection.quantity = 1;
      protection.properties["_product name"] = $(
        ".product-single__title"
      ).text();
      protection.properties["_product price"] = $(
        ".product-single__price .price__on-sale"
      ).text();
      protection.properties["_product SKU"] = $(
        ".product-single__sku span"
      ).text();
      protection.properties["_timestamp"] = timestamp;
      return protection;
    },
    buySettingWithBand: function (_this, timestamp, active_protection_plan) {
      var product_data = _this.serializeArray();
      var engagementRing = { id: "", quantity: "", properties: {} },
        formData = { items: [] },
        matchingBand = { id: "", quantity: "", properties: {} };
      product_data.forEach(function (data) {
        if (data.name.indexOf("properties") > -1 && data.value.length > 0) {
          var property = data.name.split("properties[")[1].split("]")[0];
          engagementRing.properties[property] = data.value;
          if (data.name.indexOf("properties[Size]") > -1) {
            matchingBand.properties[property] = data.value;
          }
        }
        if (data.name == "id") {
          engagementRing.id = data.value;
          engagementRing.quantity = 1;
        }
        if (data.name == "matching-band-variant") {
          matchingBand.id = data.value;
          matchingBand.quantity = 1;
          matchingBand.properties["_timestamp"] = Date.now() + 1;
        }
      });
      formData.items.push(matchingBand);
      formData.items.push(engagementRing);
      if (active_protection_plan && active_protection_plan.length) {
        var protection = { id: "", quantity: "", properties: {} };
        var protection_product = productPage.protection_product_info(
          protection,
          timestamp,
          active_protection_plan
        );
        formData.items.push(protection_product);
      }
      axios
        .post(`/cart/add.js`, formData)
        .then(({ data }) => {
          window.location.href = "/cart";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    buyProductWithProtection: function (
      _this,
      timestamp,
      active_protection_plan
    ) {
      var form_data = _this.serializeArray();
      var product_data = { id: "", quantity: "", properties: {} },
        protection = { id: "", quantity: "", properties: {} },
        formData = { items: [] };
      // Product details data required for add to cart
      form_data.forEach(function (data) {
        if (data.name.indexOf("properties") > -1 && data.value.length > 0) {
          var property = data.name.split("properties[")[1].split("]")[0];
          product_data.properties[property] = data.value;
        }
        if (data.name == "id") {
          product_data.id = data.value;
          product_data.quantity = 1;
        }
      });
      var protection_product_info = productPage.protection_product_info(
        protection,
        timestamp,
        active_protection_plan
      );
      formData.items.push(product_data);
      formData.items.push(protection_product_info);
      console.log(formData);
      // return false;
      axios
        .post(`/cart/add.js`, formData)
        .then(({ data }) => {
          window.location.href = "/cart";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    protection_price_range: function (variant_price) {
      try {
        var is_bridal_product = theme.product.is_bridal,
          protection_variant_list;
        if (is_bridal_product) {
          protection_variant_list = theme.protection_product_lifetime;
        } else {
          protection_variant_list = theme.protection_product_3y;
          $("#product-protection-option-1").val("1 Year");
          $("#product-protection-option-2").val("2 Year");
          $("#product-protection-option-3").val("3 Year");
          $(".protection-option-1 .update-year").text("1 Year");
          $(".protection-option-2 .update-year").text("2 Year");
          $(".protection-option-3 .update-year").text("3 Year");
          $(".protection-option-3 sup").hide();
        }
        var price_range = "";
        for (var obj in protection_variant_list) {
          var lower_price_range = obj.split(" / ")[1].split("-")[0] * 100;
          var higher_price_range = obj.split(" / ")[1].split("-")[1] * 100;
          if (
            variant_price >= lower_price_range &&
            variant_price <= higher_price_range
          ) {
            price_range = obj.split(" / ")[1];
            break;
          }
        }
        if (!price_range.length) {
          $(".product-clarity-commitment").hide();
          $(".product-clarity-commitment .protection-plan-wrapper input").prop(
            "checked",
            false
          );
          return false;
        }
        // console.log(protection_variant_list[`3 / ${price_range}`]);
        if (is_bridal_product) {
          return [
            ...protection_variant_list[`3 / ${price_range}`],
            ...protection_variant_list[`5 / ${price_range}`],
            ...protection_variant_list[`Lifetime / ${price_range}`],
          ];
        } else {
          return [
            ...protection_variant_list[`1 / ${price_range}`],
            ...protection_variant_list[`2 / ${price_range}`],
            ...protection_variant_list[`3 / ${price_range}`],
          ];
        }
      } catch (e) {
        console.log(e);
      }
    },
    variant_update_protection_price: function (data) {
      try {
        var [
          price_option1,
          variant_option1,
          price_option2,
          variant_option2,
          price_option3,
          variant_option3,
        ] = productPage.protection_price_range(data);
        $(".protection-option-1")
          .attr("data-protection-id", variant_option1)
          .find("p .update-price")
          .text(theme.Currency.formatMoney(price_option1, theme.moneyFormat));
        $(".protection-option-2")
          .attr("data-protection-id", variant_option2)
          .find("p .update-price")
          .text(theme.Currency.formatMoney(price_option2, theme.moneyFormat));
        $(".protection-option-3")
          .attr("data-protection-id", variant_option3)
          .find("p .update-price")
          .text(theme.Currency.formatMoney(price_option3, theme.moneyFormat));
      } catch (e) {
        console.log(e);
      }
    },
    handle_protection_plan_change: function () {
      // Code to change the protection plan tick on product page for both(i.e. product and popup)
      $(".protection-plan-wrapper label").on("click", function () {
        var closest_parent = $(this).closest(".grid__item");
        closest_parent.siblings().find("input").prop("checked", false);
        if (closest_parent.find("input").prop("checked")) {
          closest_parent.find("input").prop("checked", false);
          $(".protection-plan-wrapper .lifetime-info").hide();
        } else {
          closest_parent.find("input").prop("checked", true);
          var inputValue = closest_parent.find("input").val();
          if (inputValue == "Lifetime") {
            $(".protection-plan-wrapper .lifetime-info").show();
          } else {
            $(".protection-plan-wrapper .lifetime-info").hide();
          }
        }
      });
    },
    addToCartSubmitEvent: function () {
      // console.log(1);
      $(".product-single .product-form").on("submit", function (e) {
        const product_type = $(this)
          .closest(".product-template__container")
          .data("product-type");
        const variant_id = $('.product-form [name="id"]').val();
        var timestamp = Date.now();
        $("#properties-timestamp").val(timestamp);
        var isWeddingbandActive = $(this)
          .find("#wedding-band-checkbox")
          .prop("checked");
        // Code to add ring size if product type is 'Ring setting'
        if (product_type == "engagement-ring") {
          $("#select-setting-only-popup").addClass("show-popup-content");
          $("body").addClass("show-website-popup");
          return false;
        }
        if (product_type == "home-preview") {
          // Code to add maximum 2 home preview product
          let home_preview_count = 0;
          $.ajax({
            type: "GET",
            url: "/cart?view=home-preview",
            async: false,
            success: function (count) {
              console.log(count);
              home_preview_count = parseInt(count);
            },
          });
          console.log(home_preview_count);
          // return false;
          if (home_preview_count >= 2) {
            $(this)
              .find(".error-message")
              .text(
                "Oops! Only 2 engagement rings allowed in home preview box. Please remove items to add more."
              )
              .show();
            e.preventDefault();
            return false;
          } else if (home_preview_count == 0) {
            productPage.home_preview_ajax_add_to_cart(variant_id, $(this));
            e.preventDefault();
            return false;
          }
        }
        // Code to check ring size is selected or not if product type is ring
        const ring_size_selector = $(this).find("#product-single__ring-size");
        var character_input_length = $(this).find(
          ".swatch-character-dropdown input"
        );
        // Code to check if warranty button in enabled and if enabled add the warranty product
        var active_protection_plan = $(
          ".protection-plan-wrapper input:checked"
        );
        $(
          ".product-single__size-dropdown .error-msg,.product-form__add-to-cart-wrapper .error-msg"
        ).hide();
        if (ring_size_selector.length && ring_size_selector.val().length < 1) {
          console.log("Preventing submit event");
          $(".product-single__size-dropdown .error-msg").show();
          e.preventDefault();
          productPage.scorllToDivInMobile($(".product-single__size-dropdown"));
          return false;
        }
        if (
          character_input_length.length &&
          character_input_length.val().length < 1
        ) {
          // code to check if character input length equal to variant character limit - used for customize product
          e.preventDefault();
          $(
            ".swatch-character-dropdown .error-msg,.product-form__add-to-cart-wrapper .error-msg"
          ).html(`Minimum 1 character required to proceed.`);
          $(".swatch-character-dropdown input").css({
            border: "1px solid red",
          });
          $(".swatch-character-dropdown .error-msg").show();
          productPage.scorllToDivInMobile($(".swatch-character-dropdown"));
          return false;
        }
        if (isWeddingbandActive == true) {
          $(this).addClass("button-active disabled");
          if (active_protection_plan && active_protection_plan.length) {
            productPage.buySettingWithBand(
              $(this),
              timestamp,
              active_protection_plan
            );
          } else {
            productPage.buySettingWithBand($(this), timestamp, false);
          }
          return false;
        }
        if (active_protection_plan && active_protection_plan.length) {
          e.preventDefault();
          productPage.buyProductWithProtection(
            $(this),
            timestamp,
            active_protection_plan
          );
          return false;
        }
        $(this).addClass("button-active disabled");
      });
    },
    changeVaraintOnInput: function () {
      // Change character variant on change of character dropdown
      $(".swatch-character-dropdown input").keyup(function (e) {
        var max_input_length = 10;
        var input_character = $(this).val();
        var return_text = input_character.replace(/[^a-zA-Z0-9]/g, "");
        $(this).val(return_text);
        var input_character_len = $(this).val().length;
        $(".chracters-input-wrapper #input-counter").text(input_character_len);
        if (input_character_len < 1) {
          $(".swatch-character label[data-handle=" + 1 + "]").trigger("click");
        } else {
          $(
            ".swatch-character label[data-handle=" + input_character_len + "]"
          ).trigger("click");
        }

        // $(".swatch-character-dropdown input").attr("maxlength", character_len);
        // var new_input_value = input_value.substring(0, character_len);
        // $(".swatch-character-dropdown input").val(new_input_value);
      });
    },
    matching_band: function () {
      var matching_product = $(".matching-products");
      if (matching_product.length > 5) {
        matching_product.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: true,
          autoplay: false,
          adaptiveHeight: true,
          autoplaySpeed: 3000,
          speed: 500,
          rows: 0,
        });
      }
    },
    ringSizeChangeEvent: function () {
      if (theme.product.type == "quick-ship-engagement-ring") {
        $("#product-single__ring-size").on("change", function () {
          var ringSize = $(this).val();
          $(".product-single__size-dropdown .error-msg").hide();
          console.log(ringSize, ringSize.length);
          if (ringSize == "Less than 5" || ringSize == "More than 9") {
            $(
              ".product-form__add-to-cart-wrapper .product-form__add-to-cart"
            ).addClass("disabled");
            $(".ring-size-limit-alert").remove();
            $(".product-single__size-dropdown").append(
              '<p class="error-msg show ring-size-limit-alert">Please contact us at <a href="tel:18442346463">1.844.234.6463</a> to order a ring of that size.</p>'
            );
          } else {
            $(".ring-size-limit-alert").remove();
            $(
              ".product-form__add-to-cart-wrapper .product-form__add-to-cart"
            ).removeClass("disabled");
          }
        });
      }
    },
    hideVariantOption: function () {
      try {
        var count = 0;
        $(".swatch-diamond-type .swtach-label-wrapper div").each(function () {
          count += 1;
        });
        if (count == 1) {
          $(".swatch-diamond-type .swtach-label-wrapper").hide();
          $(".swatch-diamond-type").css("margin-bottom", 0);
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleRecommendedPresetDiamond: function (selected_option) {
      var setting_selected_shape = selected_option.data("shape_name");
      var setting_selected_color = selected_option.data("color_name");
      var diamond_information =
        JSON.parse(theme.get_local_storage("diamond-information")) || null;
      if (diamond_information) {
        $(".product-form__select-setting [data-add-to-cart-text]").text(
          "Choose Your setting"
        );
        $(".product-form__add-to-cart-wrapper").removeClass("active");
        return false;
      } else {
        $(".product-form__select-setting [data-add-to-cart-text]").text(
          "Choose A Diamond"
        );
      }
      if (
        $(".preset-ring-information") &&
        $(".preset-ring-information").length
      ) {
        var preset_all_shapes = $(".preset-ring-information div").data(
          "preset-shape"
        );
        var preset_all_color = $(".preset-ring-information div").data(
          "preset-color"
        );
        var preset_handle = $(".preset-ring-information div").data(
          "preset-handle"
        );
        // console.log(setting_selected_shape, setting_selected_color);
        // console.log(preset_all_shapes, preset_all_color, preset_handle);
        // console.log(
        //   preset_all_shapes.indexOf(setting_selected_shape) > -1 &&
        //     preset_all_color.indexOf(setting_selected_color) > -1
        // );
        if (
          preset_all_shapes.indexOf(setting_selected_shape) > -1 &&
          preset_all_color.indexOf(setting_selected_color) > -1
        ) {
          console.log(1);
          $("#select-diamond-type-popup").addClass("active");
          var preset_redirect_variant;
          var preset_variant_list = JSON.parse(
            $("#preset_variant-json").text()
          );
          for (const [key, value] of Object.entries(preset_variant_list)) {
            // console.log(key, value, value.id);
            if (
              key.indexOf(setting_selected_shape) > -1 &&
              key.indexOf(setting_selected_color) > -1
            ) {
              preset_redirect_variant = value.id;
              break;
            }
          }
          $(".btn-gemologist-pick").attr(
            "href",
            `${preset_handle}?variant=${preset_redirect_variant}`
          );
          // console.log(preset_redirect_variant);
        } else {
          $("#select-diamond-type-popup").removeClass("active");
        }
      }
    },
  };
  if (theme.product.handle) {
    productPage.carat_option_select_on_load();
    productPage.mobileImageSlider();
    productPage.swatchVariantChange();
    productPage.matching_band();
    productPage.changeVaraintOnInput();
    if (theme.product.type.length > 0) {
      productPage.accordion();
    }
    productPage.variantHeaderName();
    productPage.variantNameOnLoad();
    var on_load_variant_handle = $('[name="id"]')
      .children("option:selected")
      .data("variant-handle");
    var on_load_variant_price = $(
      ".product-single__price .price__on-sale"
    ).data("sale-price");
    productPage.changeModelImagePosition(on_load_variant_handle);
    productPage.variantShippingMsgChange(
      $('[name="id"]').children("option:selected")
    );
    productPage.addToCartSubmitEvent();
    productPage.buyNowSettingEvent();
    productPage.ringSizeChangeEvent();
    productPage.hideVariantOption();
    productPage.variant_update_protection_price(on_load_variant_price);
    productPage.handle_protection_plan_change();
    productPage.updateManualDiscount();
  }
  // Menu functionlity
  $(".site-nav__child-link--parent").on("click", function (e) {
    const closest_li_prarent = $(this).closest("li");
    const has_left_menu = closest_li_prarent.data("has-right-dropdown");
    if (has_left_menu) {
      const hasDropdown = closest_li_prarent.find(".site-nav__childlink-list");
      const downdownList = $(this)
        .closest(".engagement-rings")
        .find(".site-nav__menu-links .site-nav__childlink-list");
      console.log(hasDropdown.length);
      if (hasDropdown.length) {
        downdownList.slideDown();
      } else {
        downdownList.slideUp();
      }
      e.preventDefault();
      closest_li_prarent.siblings().removeClass("active");
      closest_li_prarent.addClass("active");
      const right_side_menu = $("#" + $(this).data("nav"));
      console.log(right_side_menu);
      //
      right_side_menu.animate({ left: 0 }, 100, function () {
        right_side_menu.siblings().css({ left: "100%" }).removeClass("active");
        right_side_menu.addClass("active");
      });
    }
  });
  // Homepage main banner desktop video autoplay
  var window_width = $(window).width();
  setTimeout(function () {
    if (window_width > 767) {
      var videoElement = document.querySelectorAll(".main-desktop-video video");
      // Log the selected descendants
      videoElement.forEach(function (video) {
        if (video.paused) {
          video.play();
        }
      });
    } else {
      var mobileVideoElement = document.querySelectorAll(
        ".main-mobile-video video"
      );
      mobileVideoElement.forEach(function (video) {
        if (video.paused) {
          video.play();
        }
      });
    }
  }, 500);
  // Homepage luxe autoplay
  var luxeHomepageVideo = document.getElementById(
    "technologyVideo-new-luxe-collection"
  ); //check file sections/homepage-video-section.liquid
  if (luxeHomepageVideo != undefined) {
    function myFunctionLuxe() {
      if (luxeHomepageVideo.paused) {
        luxeHomepageVideo.play();
      } else {
        luxeHomepageVideo.pause();
      }
    }
    myFunctionLuxe();
  }
});

// affirm.ui.ready(function () {
//   var page_template = theme.theme_template;
//   if (page_template.indexOf("product") > -1) {
//     var x = setInterval(function () {
//       var text_len = $(".affirm-as-low-as").text();
//       if (text_len.length > 0) {
//         $(".affirm-modal-trigger").text("Prequalify Now");
//         clearInterval(x);
//       }
//     }, 50);
//   }
// });

// Footer Jewelry Info
$(".jewelry-info-section .btn-show-info").on("click", function (e) {
  e.preventDefault();
  $(".jewelry-info").slideDown();
  // $(".content .text").hide();
  $(this).addClass("hide");
  $(".jewelry-info-section .btn-hide-info").removeClass("hide");
});
$(".jewelry-info-section .btn-hide-info").on("click", function (e) {
  e.preventDefault();
  $(".jewelry-info").slideUp();
  $(this).addClass("hide");
  $(".jewelry-info-section .btn-show-info").removeClass("hide");
  // $(".content .text").show();
});

function onScroll() {
  var position = $(window).scrollTop();
  var bottom = $(document).height() - $(window).height() - 1400;
  if (position > 800) {
    $(".google-reviews-snippet").addClass("active");
  } else {
    $(".google-reviews-snippet").removeClass("active");
  }
  // console.log(position, bottom);
}
$(window).scroll(function () {
  onScroll();
});
